// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T18:50:09.297Z
// Company: American Landmark
// Properties: 99 (summaries only — full data in /data/properties/*.json)

export const company = {
  "company_id": "5695708787113984",
  "company_name": "American Landmark",
  "company_url": "https://www.alapts.com/",
  "logo_url": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "icon_url": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "primary_color": "#171363",
  "primary_font": "Nobel",
  "tagline": "Your New Home Awaits",
  "about": "American Landmark Apartments is one of the fastest growing multifamily owner-operators in the United States. Based in Tampa, FL, American Landmark owns and operates multifamily communities in Georgia, Florida, North Carolina, South Carolina, Tennessee and Texas, comprised of approximately 32,000 units.\n\nThe company is committed to delivering great service and outstanding living environments to residents; delivering attractive risk-adjusted returns to investors and partners; and providing opportunities for growth, advancement, and diversity to its team members.\n\nAt American Landmark Apartments, we are passionate about creating vibrant, thriving communities and making each property a wonderful place to live. Let us help you find a place to call home.",
  "overview": null,
  "headquarters_location": null,
  "facebook_url": "https://www.facebook.com/AmericanLandmarkApts",
  "twitter_url": "",
  "instagram_url": "https://www.instagram.com/americanlandmarkapartments/",
  "linkedin_url": "https://www.linkedin.com/company/american-landmark-apartments/"
};

export const propertySummaries = [
  {
    "multihub_property_id": "5690533913559040",
    "multihub_company_id": "5695708787113984",
    "property_name": "1801 Metrowest",
    "property_slug": "1801-metrowest",
    "property_address": "1801 S Kirkman Rd",
    "property_address_1": "1801 S Kirkman Rd",
    "property_address_city": "Orlando",
    "property_address_state": "FL",
    "property_address_zip": "32811",
    "property_address_latitude": "28.5199659",
    "property_address_longitude": "-81.4560506",
    "property_phone": "(407) 293-3355",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019e8973-c0c1-71c8-8bca-9655fcabcfae.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690533913559040/019d02f2-7924-77ab-87c0-1bfb0c3efa9e.webp",
    "property_primary_color": "#003b70",
    "property_price_range": "1370.5 - 1619.66",
    "property_price_min": "1370.5",
    "property_price_max": "1619.66",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "723 - 1015",
    "property_short_description": "<p><strong>Live connected in Southwest Orlando.</strong> Explore upgraded one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with modern kitchens, screened outdoor space, and everyday conveniences designed for easy living—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see 1801 MetroWest in person.</p>",
    "property_type": "apartment",
    "property_total_units": "300",
    "property_website_url": "https://www.1801metrowest.com/",
    "property_domain": "https://www.1801metrowest.com/",
    "property_company_name": "American Landmark",
    "_slug": "1801-metrowest",
    "_stateSlug": "fl",
    "_citySlug": "orlando"
  },
  {
    "multihub_property_id": "5656808622391296",
    "multihub_company_id": "5695708787113984",
    "property_name": "2050 Morningside",
    "property_slug": "2050-morningside",
    "property_address": "2050 Cheshire Bridge Rd NE",
    "property_address_1": "2050 Cheshire Bridge Rd NE",
    "property_address_city": "Atlanta",
    "property_address_state": "GA",
    "property_address_zip": "30324",
    "property_address_latitude": "33.81219",
    "property_address_longitude": "-84.35634089999999",
    "property_phone": "(770) 299-2503",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019d02f0-49a4-753d-9b89-1eba80610943.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019df5ba-f164-739e-904d-9ed3952880f0.webp",
    "property_primary_color": "#091f40",
    "property_price_range": "1423.5 - 2108.83",
    "property_price_min": "1423.5",
    "property_price_max": "2108.83",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "657 - 1151",
    "property_short_description": "<p><strong>Artful intown living between Midtown and Buckhead.</strong> Explore polished one- and two-bedroom apartments with quartz or marble countertops, wood-plank flooring, expansive windows, and everyday ease—then schedule a tour to see 2050 Morningside in person.</p>",
    "property_type": "apartment",
    "property_total_units": "198",
    "property_website_url": "https://www.2050morningside.com/",
    "property_domain": "https://www.2050morningside.com/",
    "property_company_name": "American Landmark",
    "_slug": "2050-morningside",
    "_stateSlug": "ga",
    "_citySlug": "atlanta"
  },
  {
    "multihub_property_id": "5651440852795392",
    "multihub_company_id": "5695708787113984",
    "property_name": "8 Metro Station",
    "property_slug": "8-metro-station",
    "property_address": "5025 Wembley Central Ln",
    "property_address_1": "5025 Wembley Central Ln",
    "property_address_city": "Charlotte",
    "property_address_state": "NC",
    "property_address_zip": "28213",
    "property_address_latitude": "35.2868089",
    "property_address_longitude": "-80.7571224",
    "property_phone": "(704) 532-0580",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-030c-750a-927c-4ea35bbc5bc5.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019df5c3-023a-748c-85ce-3d824ecd184c.webp",
    "property_primary_color": "#cf4022",
    "property_price_range": "1214.16 - 2625",
    "property_price_min": "1214.16",
    "property_price_max": "2625",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "707 - 1698",
    "property_short_description": "<p><strong>Connected Charlotte living starts at the station.</strong> 8 Metro Station pairs modern one-, two-, and three-bedroom layouts with direct LYNX Blue Line access, polished apartment finishes, and resort-style spaces made for an easier everyday rhythm. <a href=\"/schedule-a-tour\">Schedule a tour</a> to see it firsthand.</p>",
    "property_type": "apartment",
    "property_total_units": "338",
    "property_website_url": "https://www.8metrostation.com/",
    "property_domain": "https://www.8metrostation.com/",
    "property_company_name": "American Landmark",
    "_slug": "8-metro-station",
    "_stateSlug": "nc",
    "_citySlug": "charlotte"
  },
  {
    "multihub_property_id": "5637285756272640",
    "multihub_company_id": "5695708787113984",
    "property_name": "Allure at Shavano",
    "property_slug": "allure-at-shavano",
    "property_address": "4601 De Zavala Rd",
    "property_address_1": "4601 De Zavala Rd",
    "property_address_city": "San Antonio",
    "property_address_state": "TX",
    "property_address_zip": "78249",
    "property_address_latitude": "29.5704965",
    "property_address_longitude": "-98.5772526",
    "property_phone": "(210) 408-6888",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-3e9c-7349-938a-200c522c4b8e.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019df5c7-9a86-7209-ab4f-dff4ffcd4fcd.webp",
    "property_primary_color": "#749ed3",
    "property_price_range": "955 - 1234.83",
    "property_price_min": "955",
    "property_price_max": "1234.83",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "522 - 937",
    "property_short_description": "<p><strong>Polished Northwest San Antonio apartments in Woods of Shavano.</strong> Allure at Shavano pairs a tucked-away, tree-lined setting off De Zavala Road with one- and two-bedroom homes featuring granite countertops, tile backsplashes, pantry storage, and everyday conveniences designed for easy living.</p>",
    "property_type": "apartment",
    "property_total_units": "200",
    "property_website_url": "https://www.allureatshavano.com/",
    "property_domain": "https://www.allureatshavano.com/",
    "property_company_name": "American Landmark",
    "_slug": "allure-at-shavano",
    "_stateSlug": "tx",
    "_citySlug": "san-antonio"
  },
  {
    "multihub_property_id": "5735011386916864",
    "multihub_company_id": "5695708787113984",
    "property_name": "Alon at Castle Hills",
    "property_slug": "alon-at-castle-hills",
    "property_address": "1835 Lockhill Selma Rd",
    "property_address_1": "1835 Lockhill Selma Rd",
    "property_address_city": "Castle Hills",
    "property_address_state": "TX",
    "property_address_zip": "78213",
    "property_address_latitude": "29.53773289999999",
    "property_address_longitude": "-98.5215882",
    "property_phone": "(210) 342-5151",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019d02f3-76d6-7491-82d0-8d0ccd995ad7.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5735011386916864/019df5cc-76f4-726c-9d4f-f840758cffc2.webp",
    "property_primary_color": "#883277",
    "property_price_range": "899 - 1493.83",
    "property_price_min": "899",
    "property_price_max": "1493.83",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "535 - 1065",
    "property_short_description": "<p><strong>Polished North Central San Antonio apartments with everyday ease.</strong> Explore one- and two-bedroom layouts with chef’s kitchens, stainless steel appliances, hardwood-style flooring, walk-in closets, and private patios or balconies—then schedule your tour at Alon at Castle Hills.</p>",
    "property_type": "apartment",
    "property_total_units": "306",
    "property_website_url": "https://www.alonatcastlehills.com/",
    "property_domain": "https://www.alonatcastlehills.com/",
    "property_company_name": "American Landmark",
    "_slug": "alon-at-castle-hills",
    "_stateSlug": "tx",
    "_citySlug": "castle-hills"
  },
  {
    "multihub_property_id": "5670511623274496",
    "multihub_company_id": "5695708787113984",
    "property_name": "Artistry at Bethesda Park",
    "property_slug": "artistry-at-bethesda-park",
    "property_address": "156 Bethesda Church Rd",
    "property_address_1": "156 Bethesda Church Rd",
    "property_address_city": "Lawrenceville",
    "property_address_state": "GA",
    "property_address_zip": "30044",
    "property_address_latitude": "33.9049448",
    "property_address_longitude": "-84.08221019999999",
    "property_phone": "(770) 921-7794",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019d02f0-a7f6-731e-8be9-a74bdb1007a1.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019df5d3-6b3c-70af-9931-4b43ad4867b3.webp",
    "property_primary_color": "#fda329",
    "property_price_range": "1367.16 - 2075",
    "property_price_min": "1367.16",
    "property_price_max": "2075",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "840 - 1492",
    "property_short_description": "<p><strong>Parkside calm, polished apartment living.</strong> Explore renovated one-, two-, and three-bedroom homes near Bethesda Park, with open layouts, stainless-steel appliances, hardwood-style flooring, generous storage, and private outdoor space in select homes—then browse available floor plans to find your fit.</p>",
    "property_type": "apartment",
    "property_total_units": "222",
    "property_website_url": "https://www.artistryatbp.com/",
    "property_domain": "https://www.artistryatbp.com/",
    "property_company_name": "American Landmark",
    "_slug": "artistry-at-bethesda-park",
    "_stateSlug": "ga",
    "_citySlug": "lawrenceville"
  },
  {
    "multihub_property_id": "5722559043600384",
    "multihub_company_id": "5695708787113984",
    "property_name": "Boulders Lakeside & Lakeview",
    "property_slug": "boulders-lakeside",
    "property_address": "1006 Boulder Lake Ter",
    "property_address_1": "1006 Boulder Lake Ter",
    "property_address_city": "North Chesterfield",
    "property_address_state": "VA",
    "property_address_zip": "23225",
    "property_address_latitude": "37.5115802",
    "property_address_longitude": "-77.53253099999999",
    "property_phone": "(804) 447-4008",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-2d70-76bc-802b-29506b6bf7b1.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019df5dc-03e9-759a-aaf1-4d10c5a3cc45.webp",
    "property_primary_color": "#16959a",
    "property_price_range": "1585 - 2370",
    "property_price_min": "1585",
    "property_price_max": "2370",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "740 - 1156",
    "property_short_description": "<p><strong>Modern lakeside living, minutes from Richmond.</strong> Discover polished one- and two-bedroom apartments with chef-inspired kitchens, hard-surface flooring, generous storage, and effortless community spaces—then start with the available floor plans to find your fit.</p>",
    "property_type": "apartment",
    "property_total_units": "460",
    "property_website_url": "https://www.bouldersalapts.com/",
    "property_domain": "https://www.bouldersalapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "boulders-lakeside",
    "_stateSlug": "va",
    "_citySlug": "north-chesterfield"
  },
  {
    "multihub_property_id": "5754272234864640",
    "multihub_company_id": "5695708787113984",
    "property_name": "Broadway Chapter",
    "property_slug": "broadway-chapter",
    "property_address": "401 Hemphill St",
    "property_address_1": "401 Hemphill St",
    "property_address_city": "Fort Worth",
    "property_address_state": "TX",
    "property_address_zip": "76104",
    "property_address_latitude": "32.7401924",
    "property_address_longitude": "-97.3312342",
    "property_phone": "(817) 415-1000",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019d02f4-3eba-731d-bbbd-a7d533f8c7e6.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5754272234864640/019e4371-7490-7517-97e1-a188e85fd6d1.webp",
    "property_primary_color": "#f8473a",
    "property_price_range": "1162.16 - 2447.16",
    "property_price_min": "1162.16",
    "property_price_max": "2447.16",
    "property_bedrooms_range": "studio - 2",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "547 - 1195",
    "property_short_description": "<p><strong>Start your next Fort Worth chapter at Broadway Chapter.</strong> Modern studio, one-, two-bedroom, and loft-style apartments pair design-forward interiors with standout spaces like a resident lounge, Zoom rooms, fitness center, and infinity-edge pool—all from a connected Near Southside address.</p>",
    "property_type": "apartment",
    "property_total_units": "242",
    "property_website_url": "https://www.broadwaychapterapts.com/",
    "property_domain": "https://www.broadwaychapterapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "broadway-chapter",
    "_stateSlug": "tx",
    "_citySlug": "fort-worth"
  },
  {
    "multihub_property_id": "5761334570385408",
    "multihub_company_id": "5695708787113984",
    "property_name": "Canopy on Central",
    "property_slug": "canopy-on-central",
    "property_address": "2700 Central Dr",
    "property_address_1": "2700 Central Dr",
    "property_address_city": "Bedford",
    "property_address_state": "TX",
    "property_address_zip": "76021",
    "property_address_latitude": "32.848882",
    "property_address_longitude": "-97.13262019999999",
    "property_phone": "(817) 858-5536",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019d02f5-3e2c-74ff-b3da-78d562ef347b.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e4380-5a44-75aa-a1c6-e874e238dfb6.webp",
    "property_primary_color": "#006aa6",
    "property_price_range": "1023.33 - 1720",
    "property_price_min": "1023.33",
    "property_price_max": "1720",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "520 - 995",
    "property_short_description": "<p><strong>Resort-style comfort in the heart of Bedford.</strong> Canopy on Central pairs garden-style one- and two-bedroom apartments with spacious closets, private patios or balconies, and everyday upgrades—all close to Mid-Cities convenience. Schedule a tour and see how home can feel here.</p>",
    "property_type": "apartment",
    "property_total_units": "706",
    "property_website_url": "https://www.canopyoncentral.com/",
    "property_domain": "https://www.canopyoncentral.com/",
    "property_company_name": "American Landmark",
    "_slug": "canopy-on-central",
    "_stateSlug": "tx",
    "_citySlug": "bedford"
  },
  {
    "multihub_property_id": "5656427712479232",
    "multihub_company_id": "5695708787113984",
    "property_name": "Cadence at Cates Creek",
    "property_slug": "cadence-at-cates-creek",
    "property_address": "100 Waterstone Park Cir",
    "property_address_1": "100 Waterstone Park Cir",
    "property_address_city": "Hillsborough",
    "property_address_state": "NC",
    "property_address_zip": "27278",
    "property_address_latitude": "36.0477977",
    "property_address_longitude": "-79.0940694",
    "property_phone": "(919) 245-8947",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019d02f0-0543-77e1-a5ee-25d8e8035cd9.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e4379-b9fc-7318-93c0-77558784c898.webp",
    "property_primary_color": "#006937",
    "property_price_range": "1205 - 1995",
    "property_price_min": "1205",
    "property_price_max": "1995",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "753 - 1509",
    "property_short_description": "<p><strong>Modern comfort with Hillsborough character.</strong> Explore one, two, and three bedroom apartments with open layouts, granite countertops, wood-style flooring, and private outdoor space—then browse <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Cadence at Cates Creek in person.</p>",
    "property_type": "apartment",
    "property_total_units": "270",
    "property_website_url": "https://www.cadenceatcatescreek.com/",
    "property_domain": "https://www.cadenceatcatescreek.com/",
    "property_company_name": "American Landmark",
    "_slug": "cadence-at-cates-creek",
    "_stateSlug": "nc",
    "_citySlug": "hillsborough"
  },
  {
    "multihub_property_id": "5697443643523072",
    "multihub_company_id": "5695708787113984",
    "property_name": "Central Station on Orange",
    "property_slug": "central-station-on-orange",
    "property_address": "480 N Orange Ave",
    "property_address_1": "480 N Orange Ave",
    "property_address_city": "Orlando",
    "property_address_state": "FL",
    "property_address_zip": "32801",
    "property_address_latitude": "28.5488276",
    "property_address_longitude": "-81.3801531",
    "property_phone": "(407) 254-0045",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019d02f2-3a17-72a4-9716-6fba939895c9.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697443643523072/019e4d01-8bfa-75af-8063-1efe310eec3d.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1415 - 3265.16",
    "property_price_min": "1415",
    "property_price_max": "3265.16",
    "property_bedrooms_range": "studio - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "532 - 1641",
    "property_short_description": "<p><strong>Downtown Orlando starts at your door.</strong> Explore studio to three-bedroom apartments with polished finishes, skyline-view spaces, and resort-style comforts in the Central Business District—then schedule a tour to see Central Station on Orange up close.</p>",
    "property_type": "apartment",
    "property_total_units": "279",
    "property_website_url": "https://www.centralstationapts.com/",
    "property_domain": "https://www.centralstationapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "central-station-on-orange",
    "_stateSlug": "fl",
    "_citySlug": "orlando"
  },
  {
    "multihub_property_id": "5694569974857728",
    "multihub_company_id": "5695708787113984",
    "property_name": "City Harbor",
    "property_slug": "city-harbor",
    "property_address": "2395 Woodwind Trl",
    "property_address_1": "2395 Woodwind Trail",
    "property_address_city": "Melbourne",
    "property_address_state": "FL",
    "property_address_zip": "32935",
    "property_address_latitude": "28.1464402",
    "property_address_longitude": "-80.66539499999999",
    "property_phone": "(321) 242-9191",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019d02f1-aa08-733b-97b4-1a404d227eee.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5694569974857728/019e4d09-25c7-754d-9594-afd1229b7644.webp",
    "property_primary_color": "#276092",
    "property_price_range": "1281.66 - 2091",
    "property_price_min": "1281.66",
    "property_price_max": "2091",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "700 - 1025",
    "property_short_description": "<p><strong>Relaxed Melbourne living starts here.</strong> Discover City Harbor’s one-, two-, and three-bedroom apartments with polished finishes, a quiet lake setting, and resort-inspired spaces made for everyday ease—then schedule your tour to see it all in person.</p>",
    "property_type": "apartment",
    "property_total_units": "208",
    "property_website_url": "https://www.cityharborapts.com/",
    "property_domain": "https://www.cityharborapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "city-harbor",
    "_stateSlug": "fl",
    "_citySlug": "melbourne"
  },
  {
    "multihub_property_id": "5737427910000640",
    "multihub_company_id": "5695708787113984",
    "property_name": "Cavalli at Iron Horse Station",
    "property_slug": "cavalli-at-iron-horse-station",
    "property_address": "6490 Iron Horse Blvd",
    "property_address_1": "6490 Iron Horse Blvd",
    "property_address_city": "North Richland Hills",
    "property_address_state": "TX",
    "property_address_zip": "76180",
    "property_address_latitude": "32.8459713",
    "property_address_longitude": "-97.24484939999999",
    "property_phone": "(469) 892-7100",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019d02f4-1ca8-7625-bad6-658fbc936140.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5737427910000640/019e4389-b457-734f-8cab-00e3bb38ec29.webp",
    "property_primary_color": "#444b2c",
    "property_price_range": "1273.33 - 2280.16",
    "property_price_min": "1273.33",
    "property_price_max": "2280.16",
    "property_bedrooms_range": "studio - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "605 - 1298",
    "property_short_description": "<p><strong>Polished apartment living in North Richland Hills.</strong> Explore modern studio to three-bedroom <a href=\"/floor-plans\">floor plans</a> with elevated finishes, inviting community spaces, and easy access to daily conveniences—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Cavalli at Iron Horse Station in person.</p>",
    "property_type": "apartment",
    "property_total_units": "328",
    "property_website_url": "https://www.lifeatcavalli.com/",
    "property_domain": "https://www.lifeatcavalli.com/",
    "property_company_name": "American Landmark",
    "_slug": "cavalli-at-iron-horse-station",
    "_stateSlug": "tx",
    "_citySlug": "north-richland-hills"
  },
  {
    "multihub_property_id": "5767618778628096",
    "multihub_company_id": "5695708787113984",
    "property_name": "Clear Springs",
    "property_slug": "clear-springs",
    "property_address": "1767 S State Highway 46",
    "property_address_1": "1767 TX-46",
    "property_address_city": "New Braunfels",
    "property_address_state": "TX",
    "property_address_zip": "78130",
    "property_address_latitude": "29.675722",
    "property_address_longitude": "-98.0569148",
    "property_phone": "(830) 837-5885",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019f1a6f-c2f0-7619-9550-9b317b4e179e.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767618778628096/019e4d0c-2255-723b-9933-b6e73993bcdb.webp",
    "property_primary_color": "#6ba3b9",
    "property_price_range": "888.16 - 1332.5",
    "property_price_min": "888.16",
    "property_price_max": "1332.5",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "499 - 937",
    "property_short_description": "<p><strong>Modern comfort with Hill Country momentum.</strong> Clear Springs pairs polished one- and two-bedroom apartments with everyday conveniences along TX-46 in New Braunfels—schedule a tour and see how easy home can feel.</p>",
    "property_type": "apartment",
    "property_total_units": "276",
    "property_website_url": "https://www.clearspringsapts.com/",
    "property_domain": "https://www.clearspringsapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "clear-springs",
    "_stateSlug": "tx",
    "_citySlug": "new-braunfels"
  },
  {
    "multihub_property_id": "5717049565249536",
    "multihub_company_id": "5695708787113984",
    "property_name": "Compass",
    "property_slug": "compass",
    "property_address": "3595 Misty Oak Dr",
    "property_address_1": "3595 Misty Oak Dr",
    "property_address_city": "Melbourne",
    "property_address_state": "FL",
    "property_address_zip": "32901",
    "property_address_latitude": "28.0539711",
    "property_address_longitude": "-80.6233256",
    "property_phone": "(321) 984-3161",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019d02f2-f00c-7266-8d0d-7a52623dd271.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e4d65-f800-77d7-9125-a26f36b136e4.webp",
    "property_primary_color": "#8e8f66",
    "property_price_range": "1247.5 - 1728.66",
    "property_price_min": "1247.5",
    "property_price_max": "1728.66",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "540 - 1078",
    "property_short_description": "<p><strong>Waterfront ease in the heart of Melbourne.</strong> Compass pairs lake-view calm with thoughtfully designed one- and two-bedroom homes, screened outdoor space, and relaxed community features—all set for an easy day-to-day near the city’s best connections. Schedule a tour and see the home base waiting here.</p>",
    "property_type": "apartment",
    "property_total_units": "210",
    "property_website_url": "https://www.compassapartmentliving.com/",
    "property_domain": "https://www.compassapartmentliving.com/",
    "property_company_name": "American Landmark",
    "_slug": "compass",
    "_stateSlug": "fl",
    "_citySlug": "melbourne"
  },
  {
    "multihub_property_id": "5762658426945536",
    "multihub_company_id": "5695708787113984",
    "property_name": "Conrad at Concord Mills",
    "property_slug": "conrad-at-concord-mills",
    "property_address": "9015 Kings Grant Dr",
    "property_address_1": "9015 Kings Grant Dr",
    "property_address_city": "Charlotte",
    "property_address_state": "NC",
    "property_address_zip": "28262",
    "property_address_latitude": "35.3685384",
    "property_address_longitude": "-80.7321822",
    "property_phone": "(980) 237-6891",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019d02f4-dbc3-77db-931a-a9504819e165.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e4d6d-2927-703a-8c25-c96133590910.webp",
    "property_primary_color": "#006ea8",
    "property_price_range": "1105 - 1915.66",
    "property_price_min": "1105",
    "property_price_max": "1915.66",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "740 - 1430",
    "property_short_description": "<p><strong>Resort-style comfort near Concord Mills.</strong> Choose polished one-, two-, and three-bedroom apartments with granite countertops, designer cabinetry, wood-style flooring, tall ceilings, and select private outdoor space—then explore <a href=\"/floor-plans\">available floor plans</a> to find your fit.</p>",
    "property_type": "apartment",
    "property_total_units": "357",
    "property_website_url": "https://www.conradatconcordmills.com/",
    "property_domain": "https://www.conradatconcordmills.com/",
    "property_company_name": "American Landmark",
    "_slug": "conrad-at-concord-mills",
    "_stateSlug": "nc",
    "_citySlug": "charlotte"
  },
  {
    "multihub_property_id": "5734243929948160",
    "multihub_company_id": "5695708787113984",
    "property_name": "Celsius Apartment Homes",
    "property_slug": "celsius-apartment-homes",
    "property_address": "10051 Perimeter Station Dr",
    "property_address_1": "10051 Perimeter Station Dr",
    "property_address_city": "Charlotte",
    "property_address_state": "NC",
    "property_address_zip": "28216",
    "property_address_latitude": "35.3458008",
    "property_address_longitude": "-80.85265509999999",
    "property_phone": "(704) 399-8805",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019d02f4-5918-761e-8d47-609611b6229a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e4391-0349-71c4-9a43-ceada245349e.webp",
    "property_primary_color": "#989400",
    "property_price_range": "1118.33 - 2042",
    "property_price_min": "1118.33",
    "property_price_max": "2042",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "713 - 1423",
    "property_short_description": "<p><strong>Modern Northlake living with room to recharge.</strong> Explore one-, two-, and three-bedroom apartment homes with keyless entry, Nest thermostats, in-home laundry, tall ceilings, and polished finishes—then browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Celsius in Charlotte.</p>",
    "property_type": "apartment",
    "property_total_units": "449",
    "property_website_url": "https://www.celsiuscharlotte.com/",
    "property_domain": "https://www.celsiuscharlotte.com/",
    "property_company_name": "American Landmark",
    "_slug": "celsius-apartment-homes",
    "_stateSlug": "nc",
    "_citySlug": "charlotte"
  },
  {
    "multihub_property_id": "5134493690101760",
    "multihub_company_id": "5695708787113984",
    "property_name": "Eddison at Deerwood Park",
    "property_slug": "eddison-at-deerwood-park",
    "property_address": "4435 Touchton Rd E",
    "property_address_1": "4435 Touchton Rd",
    "property_address_city": "Jacksonville",
    "property_address_state": "FL",
    "property_address_zip": "32246",
    "property_address_latitude": "30.2629921",
    "property_address_longitude": "-81.54903999999999",
    "property_phone": "(904) 996-0034",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019d02ee-e944-742e-9320-1c08a235f63b.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5134493690101760/019e4d7c-cdf2-73ab-9337-1304cc98746c.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1268.33 - 2091.33",
    "property_price_min": "1268.33",
    "property_price_max": "2091.33",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "711 - 1550",
    "property_short_description": "<p><strong>Modern Southside Jacksonville living starts here.</strong> Explore renovated one-, two-, and three-bedroom apartments with polished finishes, spacious layouts, and everyday convenience—then schedule your tour of Eddison at Deerwood Park.</p>",
    "property_type": "apartment",
    "property_total_units": "282",
    "property_website_url": "https://www.eddisonatdeerwoodpark.com/",
    "property_domain": "https://www.eddisonatdeerwoodpark.com/",
    "property_company_name": "American Landmark",
    "_slug": "eddison-at-deerwood-park",
    "_stateSlug": "fl",
    "_citySlug": "jacksonville"
  },
  {
    "multihub_property_id": "5684048244506624",
    "multihub_company_id": "5695708787113984",
    "property_name": "Domain at Founders Parc",
    "property_slug": "domain-at-founders-parc",
    "property_address": "880 W Euless Blvd",
    "property_address_1": "880 W Euless Blvd",
    "property_address_city": "Euless",
    "property_address_state": "TX",
    "property_address_zip": "76040",
    "property_address_latitude": "32.8308783",
    "property_address_longitude": "-97.0965131",
    "property_phone": "(817) 898-5072",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019d02f0-f79c-75eb-88a6-3d323ecaa267.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e4d76-1419-76a1-8909-4044971731a4.webp",
    "property_primary_color": "#739eb5",
    "property_price_range": "1423.33 - 2835",
    "property_price_min": "1423.33",
    "property_price_max": "2835",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "673 - 1458",
    "property_short_description": "<p><strong>Modern apartment living in the heart of Euless.</strong> Explore renovated one-, two-, and three-bedroom homes with stainless-steel appliances, wood-style flooring, in-home laundry, and resort-style spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Domain at Founders Parc in person.</p>",
    "property_type": "apartment",
    "property_total_units": "285",
    "property_website_url": "https://www.domainatfoundersparc.com/",
    "property_domain": "https://www.domainatfoundersparc.com/",
    "property_company_name": "American Landmark",
    "_slug": "domain-at-founders-parc",
    "_stateSlug": "tx",
    "_citySlug": "euless"
  },
  {
    "multihub_property_id": "5695348706115584",
    "multihub_company_id": "5695708787113984",
    "property_name": "Element at Stonebridge",
    "property_slug": "element-at-stonebridge",
    "property_address": "301 Karl Linn Dr",
    "property_address_1": "301 Karl Linn Dr",
    "property_address_city": "Richmond",
    "property_address_state": "VA",
    "property_address_zip": "23225",
    "property_address_latitude": "37.4970063",
    "property_address_longitude": "-77.52751649999999",
    "property_phone": "(804) 571-2787",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019d02f1-5888-765b-803c-f7d3e7bb66e3.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5695348706115584/019e6a76-223d-7589-a615-169dba5446f2.webp",
    "property_primary_color": "#18355e",
    "property_price_range": "1385.66 - 2077.5",
    "property_price_min": "1385.66",
    "property_price_max": "2077.5",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "563 - 1260",
    "property_short_description": "<p><strong>Modern Stonebridge apartments with everyday convenience built in.</strong> Explore one- and two-bedroom homes with polished finishes, smart in-home features, and connected courtyard-style amenities—then schedule your tour of Element at Stonebridge today.</p>",
    "property_type": "apartment",
    "property_total_units": "400",
    "property_website_url": "https://www.elementatstonebridge.com/",
    "property_domain": "https://www.elementatstonebridge.com/",
    "property_company_name": "American Landmark",
    "_slug": "element-at-stonebridge",
    "_stateSlug": "va",
    "_citySlug": "richmond"
  },
  {
    "multihub_property_id": "5719836663480320",
    "multihub_company_id": "5695708787113984",
    "property_name": "Ember at Alamo Ranch",
    "property_slug": "ember-at-alamo-ranch",
    "property_address": "11022 Culebra Rd",
    "property_address_1": "11022 Culebra Rd",
    "property_address_city": "San Antonio",
    "property_address_state": "TX",
    "property_address_zip": "78253",
    "property_address_latitude": "29.49497019999999",
    "property_address_longitude": "-98.7128649",
    "property_phone": "(210) 688-0380",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019d02f2-c719-71c2-b581-3318b2c26a99.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e6a83-b96c-7526-98d6-ae37dfb2f31f.webp",
    "property_primary_color": "#000000",
    "property_price_range": "989.16 - 1417.5",
    "property_price_min": "989.16",
    "property_price_max": "1417.5",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "499 - 937",
    "property_short_description": "<p><strong>Modern Far West Side living starts here.</strong> Explore one- and two-bedroom apartments with hardwood-style flooring, walk-in closets, and select upgraded finishes, all with everyday convenience near Culebra Road—then schedule your tour at Ember at Alamo Ranch.</p>",
    "property_type": "apartment",
    "property_total_units": "204",
    "property_website_url": "https://www.emberatalamoranch.com/",
    "property_domain": "https://www.emberatalamoranch.com/",
    "property_company_name": "American Landmark",
    "_slug": "ember-at-alamo-ranch",
    "_stateSlug": "tx",
    "_citySlug": "san-antonio"
  },
  {
    "multihub_property_id": "5687332350984192",
    "multihub_company_id": "5695708787113984",
    "property_name": "Emerson at Ford Park",
    "property_slug": "emerson-at-ford-park",
    "property_address": "301 S Jupiter Rd",
    "property_address_1": "301 S Jupiter Rd",
    "property_address_city": "Allen",
    "property_address_state": "TX",
    "property_address_zip": "75002",
    "property_address_latitude": "33.0984466",
    "property_address_longitude": "-96.6567962",
    "property_phone": "(972) 396-6000",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5687332350984192/019d02f1-1985-740d-886b-be9ee8c6ac67.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5687332350984192/019e6a88-7957-70cf-a822-95c4c3a94969.webp",
    "property_primary_color": "#4d768c",
    "property_price_range": "2123.83",
    "property_price_min": "1180",
    "property_price_max": "2123.83",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "674 - 1309",
    "property_short_description": "<p><strong>Renovated comfort in a connected Allen setting.</strong> Explore open-concept one, two, and three bedroom apartments with wood-style flooring, sleek kitchens, washer/dryer convenience, and select fenced yards—then view <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
    "property_type": "apartment",
    "property_total_units": "280",
    "property_website_url": "https://www.emersonatfordpark.com/",
    "property_domain": "https://www.emersonatfordpark.com/",
    "property_company_name": "American Landmark",
    "_slug": "emerson-at-ford-park",
    "_stateSlug": "tx",
    "_citySlug": "allen"
  },
  {
    "multihub_property_id": "5727757858242560",
    "multihub_company_id": "5695708787113984",
    "property_name": "Deseo Grande",
    "property_slug": "deseo-grande",
    "property_address": "5256 International Dr",
    "property_address_1": "5256 International Dr",
    "property_address_city": "Orlando",
    "property_address_state": "FL",
    "property_address_zip": "32819",
    "property_address_latitude": "28.4655658",
    "property_address_longitude": "-81.4479247",
    "property_phone": "(407) 270-6380",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5727757858242560/019e8990-078a-745f-9067-d9cf6123e900.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5727757858242560/019e4d72-da40-724e-94e5-0e81393da3ba.webp",
    "property_primary_color": "#c84f47",
    "property_price_range": "1678.63 - 2907.76",
    "property_price_min": "1678.63",
    "property_price_max": "2907.76",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "754 - 1276",
    "property_short_description": "<p>Discover your ideal living space at Deseo Grande in Orlando, FL! Choose from stylish one, two, and three-bedroom floor plans featuring chef's kitchens, walk-in closets, and pool views. Enjoy resort-style amenities like a fitness center, game room, and relaxing cabana. Find your new home today—browse availability or schedule a tour!</p>",
    "property_type": "apartment",
    "property_total_units": "365",
    "property_website_url": "https://www.deseograndeapts.com/",
    "property_domain": "https://www.deseograndeapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "deseo-grande",
    "_stateSlug": "fl",
    "_citySlug": "orlando"
  },
  {
    "multihub_property_id": "5677123549265920",
    "multihub_company_id": "5695708787113984",
    "property_name": "Evolv",
    "property_slug": "evolv",
    "property_address": "370 N State Highway 360",
    "property_address_1": "370 N State Hwy 360",
    "property_address_city": "Mansfield",
    "property_address_state": "TX",
    "property_address_zip": "76063",
    "property_address_latitude": "32.5657618",
    "property_address_longitude": "-97.07923770000001",
    "property_phone": "(817) 477-2787",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e8996-c334-7374-a29f-0e0acdab8924.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5677123549265920/019e6a8d-48c6-7312-b28c-d01cf7eec2cf.webp",
    "property_primary_color": "#ea4e3c",
    "property_price_range": "1185 - 2097",
    "property_price_min": "1185",
    "property_price_max": "2097",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "751 - 1403",
    "property_short_description": "<p><strong>Contemporary Mansfield living with room to move.</strong> Evolv pairs open-concept one-, two-, and three-bedroom homes with granite countertops, stainless steel appliances, walk-in closets, and easy access to Highway 360—schedule your tour to see it in person.</p>",
    "property_type": "apartment",
    "property_total_units": "334",
    "property_website_url": "https://www.evolvmansfield.com/",
    "property_domain": "https://www.evolvmansfield.com/",
    "property_company_name": "American Landmark",
    "_slug": "evolv",
    "_stateSlug": "tx",
    "_citySlug": "mansfield"
  },
  {
    "multihub_property_id": "5641831400341504",
    "multihub_company_id": "5695708787113984",
    "property_name": "Fairways at Feather Sound",
    "property_slug": "fairways-at-feather-sound",
    "property_address": "13621 Feather Sound Cir E",
    "property_address_1": "13621 Feather Sound Cir E",
    "property_address_city": "Clearwater",
    "property_address_state": "FL",
    "property_address_zip": "33762",
    "property_address_latitude": "27.8971098",
    "property_address_longitude": "-82.6701157",
    "property_phone": "(727) 573-4601",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019d02ef-4b5d-705a-9a8f-610a8ef5b9d4.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e6a93-70f2-7518-8ba6-2c1932abfe81.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1501.83 - 2314.5",
    "property_price_min": "1501.83",
    "property_price_max": "2314.5",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "608 - 1060",
    "property_short_description": "<p><strong>Carefree Clearwater living in a lakeside Feather Sound setting.</strong> Explore comfortable one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> surrounded by lakes, walking trails, tropical landscaping, and resort-style spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Fairways at Feather Sound in person.</p>",
    "property_type": "apartment",
    "property_total_units": "288",
    "property_website_url": "https://www.fairwaysatfeathersound.com/",
    "property_domain": "https://www.fairwaysatfeathersound.com/",
    "property_company_name": "American Landmark",
    "_slug": "fairways-at-feather-sound",
    "_stateSlug": "fl",
    "_citySlug": "clearwater"
  },
  {
    "multihub_property_id": "5759777107869696",
    "multihub_company_id": "5695708787113984",
    "property_name": "Finley West",
    "property_slug": "finley-west",
    "property_address": "9940 Richmond Ave",
    "property_address_1": "9940 Richmond Ave",
    "property_address_city": "Houston",
    "property_address_state": "TX",
    "property_address_zip": "77042",
    "property_address_latitude": "29.7297985",
    "property_address_longitude": "-95.5463068",
    "property_phone": "(713) 780-4617",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019d02f4-e132-770b-8f41-d54453ad3007.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e6a98-8a76-729b-8c8b-f9a20b765f98.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1052.16 - 1545",
    "property_price_min": "1052.16",
    "property_price_max": "1545",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "733 - 1262",
    "property_short_description": "<p><strong>Find your Westchase home base at Finley West.</strong> Comfortable one- and two-bedroom apartments pair polished finishes with practical storage, all in a convenient west Houston location near everyday shopping, dining, and major business corridors. Schedule your tour today.</p>",
    "property_type": "apartment",
    "property_total_units": "224",
    "property_website_url": "https://www.finleywest.com/",
    "property_domain": "https://www.finleywest.com/",
    "property_company_name": "American Landmark",
    "_slug": "finley-west",
    "_stateSlug": "tx",
    "_citySlug": "houston"
  },
  {
    "multihub_property_id": "5701798404816896",
    "multihub_company_id": "5695708787113984",
    "property_name": "Hayden at Enclave",
    "property_slug": "hayden-at-enclave",
    "property_address": "12951 Briar Forest Dr",
    "property_address_1": "12951 Briar Forest Dr",
    "property_address_city": "Houston",
    "property_address_state": "TX",
    "property_address_zip": "77077",
    "property_address_latitude": "29.7520399",
    "property_address_longitude": "-95.6178688",
    "property_phone": "(281) 496-6070",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5701798404816896/019d02f1-1e34-7577-9114-d6f557db0c71.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5701798404816896/019e6aa3-990d-77ae-87c2-78a45d801a09.webp",
    "property_primary_color": "#0063a8",
    "property_price_range": "820 - 1550.66",
    "property_price_min": "820",
    "property_price_max": "1550.66",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "551 - 1470",
    "property_short_description": "<p><strong>West Houston comfort, with room to breathe.</strong> Hayden at Enclave pairs one- and two-bedroom apartment homes with relaxed courtyard-style amenities, everyday conveniences, and quick access to the Energy Corridor—schedule a tour to see it in person.</p>",
    "property_type": "apartment",
    "property_total_units": "476",
    "property_website_url": "https://www.haydenatenclave.com/",
    "property_domain": "https://www.haydenatenclave.com/",
    "property_company_name": "American Landmark",
    "_slug": "hayden-at-enclave",
    "_stateSlug": "tx",
    "_citySlug": "houston"
  },
  {
    "multihub_property_id": "5174477956579328",
    "multihub_company_id": "5695708787113984",
    "property_name": "Kenzie Park",
    "property_slug": "kenzie-park",
    "property_address": "3379 Timber View Dr",
    "property_address_1": "3379 Timber View Dr",
    "property_address_city": "San Antonio",
    "property_address_state": "TX",
    "property_address_zip": "78251",
    "property_address_latitude": "29.4700946",
    "property_address_longitude": "-98.6471679",
    "property_phone": "(210) 520-4343",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019d02ee-2d52-761b-9751-79f8a971bedd.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174477956579328/019e6fb6-f091-76d7-9f72-66def8e002e0.webp",
    "property_primary_color": "#00586e",
    "property_price_range": "797.33 - 1158",
    "property_price_min": "797.33",
    "property_price_max": "1158",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "499 - 939",
    "property_short_description": "<p><strong>Polished Westover Hills living starts here.</strong> Choose a one- or two-bedroom apartment with granite countertops, stainless steel appliances, walk-in closets, and streamlined everyday conveniences—then explore layouts or schedule a tour when you’re ready.</p>",
    "property_type": "apartment",
    "property_total_units": "312",
    "property_website_url": "https://www.kenziepark.com/",
    "property_domain": "https://www.kenziepark.com/",
    "property_company_name": "American Landmark",
    "_slug": "kenzie-park",
    "_stateSlug": "tx",
    "_citySlug": "san-antonio"
  },
  {
    "multihub_property_id": "5653950229381120",
    "multihub_company_id": "5695708787113984",
    "property_name": "Latitude at Mallard Creek",
    "property_slug": "latitude-at-mallard-creek",
    "property_address": "655 W Mallard Creek Church Rd",
    "property_address_1": "655 W Mallard Creek Church Rd",
    "property_address_city": "Charlotte",
    "property_address_state": "NC",
    "property_address_zip": "28262",
    "property_address_latitude": "35.3269135",
    "property_address_longitude": "-80.73545589999999",
    "property_phone": "(980) 819-5503",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019d02ef-a03d-730a-bc29-837ac8f25a3b.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5653950229381120/019e6fc5-30f7-77d7-a65d-aee4ade446f7.webp",
    "property_primary_color": "#a2a827",
    "property_price_range": "1145 - 1828.66",
    "property_price_min": "1145",
    "property_price_max": "1828.66",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "609 - 1406",
    "property_short_description": "<p><strong>Modern comfort in University City North.</strong> Explore polished one-, two-, and three-bedroom apartments with standout finishes, easy everyday conveniences, and resort-inspired spaces—then view <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Latitude at Mallard Creek in person.</p>",
    "property_type": "apartment",
    "property_total_units": "503",
    "property_website_url": "https://www.latitudeatmc.com/",
    "property_domain": "https://www.latitudeatmc.com/",
    "property_company_name": "American Landmark",
    "_slug": "latitude-at-mallard-creek",
    "_stateSlug": "nc",
    "_citySlug": "charlotte"
  },
  {
    "multihub_property_id": "5753165609697280",
    "multihub_company_id": "5695708787113984",
    "property_name": "Laurel Heights at Cityview",
    "property_slug": "laurel-heights-at-cityview",
    "property_address": "5701 Overton Ridge Blvd",
    "property_address_1": "5701 Overton Ridge Blvd",
    "property_address_city": "Fort Worth",
    "property_address_state": "TX",
    "property_address_zip": "76132",
    "property_address_latitude": "32.674744",
    "property_address_longitude": "-97.41447939999999",
    "property_phone": "(817) 346-6098",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019d02f3-4a06-75ab-be6a-802fb2ffc6a1.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753165609697280/019e6fc7-392e-7792-9e4f-402dc9384ba2.webp",
    "property_primary_color": "#de5f32",
    "property_price_range": "1022.66 - 1579.83",
    "property_price_min": "1022.66",
    "property_price_max": "1579.83",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "550 - 1040",
    "property_short_description": "<p><strong>Southwest Fort Worth comfort, Cityview convenience.</strong> Laurel Heights at Cityview pairs polished one and two bedroom apartments with open-concept kitchens, granite countertops, walk-in closets, and private outdoor space—plus resort-style community perks. <a href=\"/schedule-a-tour\">Schedule a tour</a> today.</p>",
    "property_type": "apartment",
    "property_total_units": "440",
    "property_website_url": "https://www.laurelheightsapts.com/",
    "property_domain": "https://www.laurelheightsapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "laurel-heights-at-cityview",
    "_stateSlug": "tx",
    "_citySlug": "fort-worth"
  },
  {
    "multihub_property_id": "5646289643503616",
    "multihub_company_id": "5695708787113984",
    "property_name": "Macallan On Ross",
    "property_slug": "macallan-on-ross",
    "property_address": "3501 Ross Ave",
    "property_address_1": "3501 Ross Ave",
    "property_address_city": "Dallas",
    "property_address_state": "TX",
    "property_address_zip": "75204",
    "property_address_latitude": "32.7973558",
    "property_address_longitude": "-96.7885452",
    "property_phone": "(214) 821-3370",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019d02ef-826e-77cb-9ed0-48cc3d476508.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5646289643503616/019e6fd4-d78b-77aa-b4ec-deeac1a9a09e.webp",
    "property_primary_color": "#8b2233",
    "property_price_range": "1220.16 - 2007",
    "property_price_min": "1220.16",
    "property_price_max": "2007",
    "property_bedrooms_range": "studio - 2",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "504 - 1173",
    "property_short_description": "<p><strong>Live connected on Ross Avenue.</strong> Macallan On Ross pairs studio, one-, and two-bedroom apartments with polished finishes, effortless community spaces, and a central Dallas address made for easy everyday movement. Explore the <a href=\"/floor-plans\">floor plans</a>, browse the <a href=\"/gallery\">gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
    "property_type": "apartment",
    "property_total_units": "368",
    "property_website_url": "https://www.macallanonross.com/",
    "property_domain": "https://www.macallanonross.com/",
    "property_company_name": "American Landmark",
    "_slug": "macallan-on-ross",
    "_stateSlug": "tx",
    "_citySlug": "dallas"
  },
  {
    "multihub_property_id": "5682633027616768",
    "multihub_company_id": "5695708787113984",
    "property_name": "McAlister",
    "property_slug": "mcalister",
    "property_address": "450 El Dorado Blvd",
    "property_address_1": "450 El Dorado Blvd",
    "property_address_city": "Webster",
    "property_address_state": "TX",
    "property_address_zip": "77598",
    "property_address_latitude": "29.5589655",
    "property_address_longitude": "-95.1428811",
    "property_phone": "(281) 480-3303",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019d02f1-3711-7697-be5c-d44e0f76be21.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5682633027616768/019e6fdd-175d-70ec-a9ef-bb514eaa19e5.webp",
    "property_primary_color": "#81392d",
    "property_price_range": "899.33 - 1544.66",
    "property_price_min": "899.33",
    "property_price_max": "1544.66",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "552 - 1210",
    "property_short_description": "<p><strong>Live close to the best of Clear Lake.</strong> McAlister pairs easygoing one- and two-bedroom apartment living with relaxed community spaces and a connected Webster location—explore the floor plans and see what feels like home.</p>",
    "property_type": "apartment",
    "property_total_units": "214",
    "property_website_url": "https://www.mcalisterliving.com/",
    "property_domain": "https://www.mcalisterliving.com/",
    "property_company_name": "American Landmark",
    "_slug": "mcalister",
    "_stateSlug": "tx",
    "_citySlug": "webster"
  },
  {
    "multihub_property_id": "5174219562287104",
    "multihub_company_id": "5695708787113984",
    "property_name": "Mosaic at Miramar Town Center",
    "property_slug": "mosaic-at-miramar-town-center",
    "property_address": "11575 City Hall Promenade",
    "property_address_1": "11575 City Hall Promenade",
    "property_address_city": "Miramar",
    "property_address_state": "FL",
    "property_address_zip": "33025",
    "property_address_latitude": "25.9856869",
    "property_address_longitude": "-80.29843919999999",
    "property_phone": "(954) 499-0502",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019d02ee-8ea8-760f-8f1a-8572a41abc09.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e6ff2-24b3-75f1-9ef2-3c1a4c798498.webp",
    "property_primary_color": "#4a4745",
    "property_price_range": "2139.5 - 3522",
    "property_price_min": "2139.5",
    "property_price_max": "3522",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "700 - 1566",
    "property_short_description": "<p><strong>Live at the center of Miramar’s everyday energy.</strong> Mosaic at Miramar Town Center offers polished apartments and townhome-style layouts with condo-inspired finishes, walkable conveniences, and easy South Florida connections. Explore spacious floor plans and schedule your tour today.</p>",
    "property_type": "apartment",
    "property_total_units": "487",
    "property_website_url": "https://www.mosaicatmiramar.com/",
    "property_domain": "https://www.mosaicatmiramar.com/",
    "property_company_name": "American Landmark",
    "_slug": "mosaic-at-miramar-town-center",
    "_stateSlug": "fl",
    "_citySlug": "miramar"
  },
  {
    "multihub_property_id": "5652147039371264",
    "multihub_company_id": "5695708787113984",
    "property_name": "Lodge @ 1550",
    "property_slug": "lodge-@-1550",
    "property_address": "1550 Katy Flewellen Rd",
    "property_address_1": "1550 Katy Flewellen Rd",
    "property_address_city": "Katy",
    "property_address_state": "TX",
    "property_address_zip": "77494",
    "property_address_latitude": "29.7670101",
    "property_address_longitude": "-95.82252799999999",
    "property_phone": "(281) 392-2787",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019d02ef-1574-70dc-b240-759c996b8517.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e6fd2-6756-712b-b6a2-340a39c86eb7.webp",
    "property_primary_color": "#75994a",
    "property_price_range": "1015 - 1640.5",
    "property_price_min": "1015",
    "property_price_max": "1640.5",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "532 - 946",
    "property_short_description": "<p><strong>Relaxed Katy living, polished where it counts.</strong> Discover updated one- and two-bedroom apartments with elevated finishes, everyday comfort, and calm landscaped surroundings—then schedule your tour of Lodge @ 1550 today.</p>",
    "property_type": "apartment",
    "property_total_units": "204",
    "property_website_url": "https://www.lodgeat1550.com/",
    "property_domain": "https://www.lodgeat1550.com/",
    "property_company_name": "American Landmark",
    "_slug": "lodge-1550",
    "_stateSlug": "tx",
    "_citySlug": "katy"
  },
  {
    "multihub_property_id": "5191322281443328",
    "multihub_company_id": "5695708787113984",
    "property_name": "Neo at Ten",
    "property_slug": "neo-at-ten",
    "property_address": "14805 Grisby Rd",
    "property_address_1": "14805 Grisby Rd",
    "property_address_city": "Houston",
    "property_address_state": "TX",
    "property_address_zip": "77079",
    "property_address_latitude": "29.7818386",
    "property_address_longitude": "-95.64558799999999",
    "property_phone": "(281) 556-5006",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019d02ee-7ae4-74b9-8f31-41149ab557e8.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5191322281443328/019e6ff5-b666-74f5-a789-f2f5c30d0aa5.webp",
    "property_primary_color": "#5d55c1",
    "property_price_range": "1126.66 - 1953.33",
    "property_price_min": "1126.66",
    "property_price_max": "1953.33",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "575 - 1444",
    "property_short_description": "<p><strong>Modern Energy Corridor living with room to recharge.</strong> Explore polished one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> near I-10 and Highway 6, with elevated finishes, private outdoor space, and resort-inspired amenities designed to make West Houston feel like home.</p>",
    "property_type": "apartment",
    "property_total_units": "293",
    "property_website_url": "https://www.neoatten.com/",
    "property_domain": "https://www.neoatten.com/",
    "property_company_name": "American Landmark",
    "_slug": "neo-at-ten",
    "_stateSlug": "tx",
    "_citySlug": "houston"
  },
  {
    "multihub_property_id": "5712947535937536",
    "multihub_company_id": "5695708787113984",
    "property_name": "Onyx Winter Park",
    "property_slug": "onyx-winter-park",
    "property_address": "100 Reflections Cir",
    "property_address_1": "100 Reflections Cir",
    "property_address_city": "Casselberry",
    "property_address_state": "FL",
    "property_address_zip": "32707",
    "property_address_latitude": "28.6304456",
    "property_address_longitude": "-81.31722719999999",
    "property_phone": "(407) 678-7555",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019d02f2-20a3-72ba-85fc-7e7dbe7cb1ef.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019d02f1-4904-74ad-9730-51da0da77d81.webp",
    "property_primary_color": "#0081bb",
    "property_price_range": "1227.33 - 1837",
    "property_price_min": "1227.33",
    "property_price_max": "1837",
    "property_bedrooms_range": "studio - 2",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "460 - 998",
    "property_short_description": "<p><strong>Lake Howell calm, Winter Park energy.</strong> Discover garden-style studio, one-, and two-bedroom apartments with modern finishes, select lake views, and resort-inspired everyday spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Onyx Winter Park for yourself.</p>",
    "property_type": "apartment",
    "property_total_units": "336",
    "property_website_url": "https://www.onyxwinterpark.com/",
    "property_domain": "https://www.onyxwinterpark.com/",
    "property_company_name": "American Landmark",
    "_slug": "onyx-winter-park",
    "_stateSlug": "fl",
    "_citySlug": "casselberry"
  },
  {
    "multihub_property_id": "5720221574758400",
    "multihub_company_id": "5695708787113984",
    "property_name": "Opal at Barker Cypress",
    "property_slug": "opal-at-barker-cypress",
    "property_address": "2926 Barker Cypress Rd",
    "property_address_1": "2926 Barker Cypress Rd",
    "property_address_city": "Houston",
    "property_address_state": "TX",
    "property_address_zip": "77084",
    "property_address_latitude": "29.8104318",
    "property_address_longitude": "-95.6862294",
    "property_phone": "(281) 492-0200",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5720221574758400/019d02f3-2837-72b4-a004-ee128bf079d9.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5720221574758400/019e6fff-f613-7069-af1c-7ce37244399f.webp",
    "property_primary_color": "#0d4c92",
    "property_price_range": "1296.66 - 2584.33",
    "property_price_min": "1296.66",
    "property_price_max": "2584.33",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "634 - 1424",
    "property_short_description": "<p><strong>Modern West Houston apartments with room to live your way.</strong> Explore spacious one-, two-, and three-bedroom homes with quartz countertops, stainless-steel appliances, in-home laundry, and private outdoor space—then schedule your tour at Opal at Barker Cypress.</p>",
    "property_type": "apartment",
    "property_total_units": "364",
    "property_website_url": "https://www.opalatbarkercypress.com/",
    "property_domain": "https://www.opalatbarkercypress.com/",
    "property_company_name": "American Landmark",
    "_slug": "opal-at-barker-cypress",
    "_stateSlug": "tx",
    "_citySlug": "houston"
  },
  {
    "multihub_property_id": "5757210235764736",
    "multihub_company_id": "5695708787113984",
    "property_name": "Parc at Murfreesboro",
    "property_slug": "parc-at-murfreesboro",
    "property_address": "3237 Memorial Blvd",
    "property_address_1": "3237 Memorial Blvd",
    "property_address_city": "Murfreesboro",
    "property_address_state": "TN",
    "property_address_zip": "37129",
    "property_address_latitude": "35.9042471",
    "property_address_longitude": "-86.38613459999999",
    "property_phone": "(615) 686-2414",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019d02f3-a799-70b3-ae7d-49c6c37e6b68.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e700d-cfd8-75c0-9c9a-cdb957df7550.webp",
    "property_primary_color": "#155408",
    "property_price_range": "1385 - 2523.83",
    "property_price_min": "1385",
    "property_price_max": "2523.83",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "686 - 1403",
    "property_short_description": "<p><strong>Modern Murfreesboro living starts at Parc.</strong> Explore polished one-, two-, and three-bedroom apartments with contemporary finishes, smart home features, and inviting spaces to unwind—then schedule your tour to see it all in person.</p>",
    "property_type": "apartment",
    "property_total_units": "359",
    "property_website_url": "https://www.parcatmurfreesboro.com",
    "property_domain": "https://www.parcatmurfreesboro.com/",
    "property_company_name": "American Landmark",
    "_slug": "parc-at-murfreesboro",
    "_stateSlug": "tn",
    "_citySlug": "murfreesboro"
  },
  {
    "multihub_property_id": "5091000275959808",
    "multihub_company_id": "5695708787113984",
    "property_name": "Phillips Pass",
    "property_slug": "phillips-pass",
    "property_address": "2323 Eldridge Pkwy",
    "property_address_1": "2323 Eldridge Pkwy",
    "property_address_city": "Houston",
    "property_address_state": "TX",
    "property_address_zip": "77077",
    "property_address_latitude": "29.7408675",
    "property_address_longitude": "-95.62289369999999",
    "property_phone": "(281) 759-4064",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019d02ee-06fd-72fa-8ceb-78a43340da9c.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5091000275959808/019e7010-eb83-7383-89dc-5ff12bea220d.webp",
    "property_primary_color": "#093d52",
    "property_price_range": "995.83 - 1515",
    "property_price_min": "995.83",
    "property_price_max": "1515",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "708 - 1148",
    "property_short_description": "<p><strong>Upscale comfort in Briar Village.</strong> Spacious one- and two-bedroom apartments pair polished finishes with everyday ease—then extend home with resort-inspired amenities on Eldridge Parkway. Browse <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> of Phillips Pass today.</p>",
    "property_type": "apartment",
    "property_total_units": "168",
    "property_website_url": "https://www.phillipspass.com/",
    "property_domain": "https://www.phillipspass.com/",
    "property_company_name": "American Landmark",
    "_slug": "phillips-pass",
    "_stateSlug": "tx",
    "_citySlug": "houston"
  },
  {
    "multihub_property_id": "5712550654115840",
    "multihub_company_id": "5695708787113984",
    "property_name": "Mercantile River District",
    "property_slug": "mercantile-river-district",
    "property_address": "4921 White Settlement Rd",
    "property_address_1": "4921 White Settlement Rd",
    "property_address_city": "Fort Worth",
    "property_address_state": "TX",
    "property_address_zip": "76114",
    "property_address_latitude": "32.7596438",
    "property_address_longitude": "-97.3972467",
    "property_phone": "(682) 708-8484",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019d02f1-5f4c-72f8-9342-8c590bf2edd2.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712550654115840/019e6fe0-e565-74ac-aca1-c8f9f52aa7bb.webp",
    "property_primary_color": "#313c4c",
    "property_price_range": "1306.33 - 3194.66",
    "property_price_min": "1306.33",
    "property_price_max": "3194.66",
    "property_bedrooms_range": "studio - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 3.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "3.5",
    "property_sqft_range": "491 - 2031",
    "property_short_description": "<p><strong>River District energy, resort-style ease.</strong> Discover polished studio to three-bedroom homes with elevated finishes, smart-home touches, and relaxed spaces made for everyday recharge—then explore the floor plans and amenities that bring Mercantile River District to life.</p>",
    "property_type": "apartment",
    "property_total_units": "325",
    "property_website_url": "https://www.mercantileriverdistrict.com/",
    "property_domain": "https://www.mercantileriverdistrict.com/",
    "property_company_name": "American Landmark",
    "_slug": "mercantile-river-district",
    "_stateSlug": "tx",
    "_citySlug": "fort-worth"
  },
  {
    "multihub_property_id": "5757666374713344",
    "multihub_company_id": "5695708787113984",
    "property_name": "Palmetto Pointe",
    "property_slug": "palmetto-pointe",
    "property_address": "4835 Usaa Blvd",
    "property_address_1": "4835 Usaa Blvd",
    "property_address_city": "San Antonio",
    "property_address_state": "TX",
    "property_address_zip": "78240",
    "property_address_latitude": "29.5370282",
    "property_address_longitude": "-98.5809227",
    "property_phone": "(210) 667-4835",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7f16-7259-b0dc-b12f3e0625ab.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e700a-597a-777a-a5ef-fb1669d40b5a.webp",
    "property_primary_color": "#eabb4e",
    "property_price_range": "1198.83 - 1944.33",
    "property_price_min": "1198.83",
    "property_price_max": "1944.33",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "653 - 1451",
    "property_short_description": "<p><strong>Upscale Medical Center living starts here.</strong> Explore spacious one- and two-bedroom apartments with polished finishes, private patios, and resort-style spaces designed for easy downtime—then schedule your tour of Palmetto Pointe today.</p>",
    "property_type": "apartment",
    "property_total_units": "328",
    "property_website_url": "https://www.palmettopointeliving.com/",
    "property_domain": "https://www.palmettopointeliving.com/",
    "property_company_name": "American Landmark",
    "_slug": "palmetto-pointe",
    "_stateSlug": "tx",
    "_citySlug": "san-antonio"
  },
  {
    "multihub_property_id": "5673855012044800",
    "multihub_company_id": "5695708787113984",
    "property_name": "Ranch at Hudson Xing",
    "property_slug": "ranch-at-hudson-xing",
    "property_address": "3250 Hudson Xing",
    "property_address_1": "3250 Hudson Crossing",
    "property_address_city": "McKinney",
    "property_address_state": "TX",
    "property_address_zip": "75070",
    "property_address_latitude": "33.1714755",
    "property_address_longitude": "-96.7042512",
    "property_phone": "(972) 542-4500",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019d02ef-b0b1-71eb-877e-0c4c31d84ef6.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5673855012044800/019e7015-75b6-7268-8d66-b7f9b9c6219b.webp",
    "property_primary_color": "#1c4026",
    "property_price_range": "1206.83 - 2024.16",
    "property_price_min": "1206.83",
    "property_price_max": "2024.16",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "621 - 1185",
    "property_short_description": "<p><strong>Parkside McKinney living with everyday polish.</strong> Ranch at Hudson Xing pairs one-, two-, and three-bedroom homes with polished finishes, private outdoor space, and community comforts beside open green space—schedule a tour to see it all in person.</p>",
    "property_type": "apartment",
    "property_total_units": "248",
    "property_website_url": "https://www.ranchathudsonxing.com/",
    "property_domain": "https://www.ranchathudsonxing.com/",
    "property_company_name": "American Landmark",
    "_slug": "ranch-at-hudson-xing",
    "_stateSlug": "tx",
    "_citySlug": "mckinney"
  },
  {
    "multihub_property_id": "5716675206840320",
    "multihub_company_id": "5695708787113984",
    "property_name": "Scout Landing",
    "property_slug": "scout-landing",
    "property_address": "261 Veterans Pkwy",
    "property_address_1": "261 Veterans Pkwy",
    "property_address_city": "Murfreesboro",
    "property_address_state": "TN",
    "property_address_zip": "37128",
    "property_address_latitude": "35.7836707",
    "property_address_longitude": "-86.4057581",
    "property_phone": "(615) 848-1022",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019d02f1-e23c-7254-85c6-14192ecaa69d.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5716675206840320/019e7020-7b4f-7058-8cb0-3a8afd5585c3.webp",
    "property_primary_color": "#1b448b",
    "property_price_range": "1209.66 - 1885.83",
    "property_price_min": "1209.66",
    "property_price_max": "1885.83",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "529 - 1340",
    "property_short_description": "<p><strong>House-like comfort meets polished apartment style at Scout Landing.</strong> Explore one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with standout finishes like granite countertops, stainless steel appliances, hardwood-style flooring, in-home laundry, and select loft layouts with vaulted ceilings—then <a href=\"/schedule-a-tour\">schedule a tour</a> to find your fit.</p>",
    "property_type": "apartment",
    "property_total_units": "278",
    "property_website_url": "https://www.scoutlanding.com/",
    "property_domain": "https://www.scoutlanding.com/",
    "property_company_name": "American Landmark",
    "_slug": "scout-landing",
    "_stateSlug": "tn",
    "_citySlug": "murfreesboro"
  },
  {
    "multihub_property_id": "5700260269654016",
    "multihub_company_id": "5695708787113984",
    "property_name": "Stone Creek at The Woodlands",
    "property_slug": "stone-creek-at-the-woodlands",
    "property_address": "3600 College Park Dr",
    "property_address_1": "3600 College Park Dr",
    "property_address_city": "The Woodlands",
    "property_address_state": "TX",
    "property_address_zip": "77384",
    "property_address_latitude": "30.2075598",
    "property_address_longitude": "-95.4741767",
    "property_phone": "(936) 321-0300",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019d02f1-195a-726c-ace5-fedfabd96b8f.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5700260269654016/019e702a-9e2e-73c3-a1d4-5a1b167d9239.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1067.66 - 1944",
    "property_price_min": "1067.66",
    "property_price_max": "1944",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "580 - 1386",
    "property_short_description": "<p><strong>Polished apartment living in The Woodlands’ College Park area.</strong> Explore one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with modern kitchens, granite countertops, in-home laundry, and easy access to resort-inspired spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Stone Creek at The Woodlands.</p>",
    "property_type": "apartment",
    "property_total_units": "240",
    "property_website_url": "https://www.stonecreekwoodlands.com/",
    "property_domain": "https://www.stonecreekwoodlands.com/",
    "property_company_name": "American Landmark",
    "_slug": "stone-creek-at-the-woodlands",
    "_stateSlug": "tx",
    "_citySlug": "the-woodlands"
  },
  {
    "multihub_property_id": "5710961784651776",
    "multihub_company_id": "5695708787113984",
    "property_name": "Switchyard",
    "property_slug": "switchyard",
    "property_address": "1199 N Broadway St",
    "property_address_1": "1199 N Broadway St",
    "property_address_city": "Carrollton",
    "property_address_state": "TX",
    "property_address_zip": "75006",
    "property_address_latitude": "32.9554617",
    "property_address_longitude": "-96.9097717",
    "property_phone": "(972) 695-6323",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019d02f1-d6ed-75bf-b24a-bf47aae56823.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019d02f1-2d8f-7154-9f4d-0b91882f62eb.webp",
    "property_primary_color": "#ffa300",
    "property_price_range": "953 - 2453.33",
    "property_price_min": "953",
    "property_price_max": "2453.33",
    "property_bedrooms_range": "studio - 2",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "525 - 1262",
    "property_short_description": "<p><strong>Downtown Carrollton style, polished for everyday ease.</strong> Switchyard pairs modern industrial character with studio, one-, and two-bedroom apartments featuring elevated finishes, in-home washer and dryer convenience, and connected community spaces made for effortless living.</p>",
    "property_type": "apartment",
    "property_total_units": "234",
    "property_website_url": "https://www.switchyardliving.com",
    "property_domain": "https://www.switchyardliving.com/",
    "property_company_name": "American Landmark",
    "_slug": "switchyard",
    "_stateSlug": "tx",
    "_citySlug": "carrollton"
  },
  {
    "multihub_property_id": "5713142352969728",
    "multihub_company_id": "5695708787113984",
    "property_name": "Tapestry Westland Village",
    "property_slug": "tapestry-westland-village",
    "property_address": "6505 Collins Rd",
    "property_address_1": "6505 Collins Rd",
    "property_address_city": "Jacksonville",
    "property_address_state": "FL",
    "property_address_zip": "32244",
    "property_address_latitude": "30.20724439999999",
    "property_address_longitude": "-81.7496456",
    "property_phone": "(904) 420-8033",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f3-3440-7494-a4be-3c391acb9c8c.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e7030-ed2e-7399-917f-b6268caafce5.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1318.5 - 2195.5",
    "property_price_min": "1318.5",
    "property_price_max": "2195.5",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "725 - 1324",
    "property_short_description": "<p><strong>Modern Westside Jacksonville living, with room to unwind.</strong> Explore polished studio to three-bedroom apartments with chef-inspired kitchens, granite countertops, stainless-steel appliances, and resort-style spaces designed for everyday ease—then schedule a tour of Tapestry Westland Village.</p>",
    "property_type": "apartment",
    "property_total_units": "266",
    "property_website_url": "https://www.tapestrywestlandvillage.com/",
    "property_domain": "https://www.tapestrywestlandvillage.com/",
    "property_company_name": "American Landmark",
    "_slug": "tapestry-westland-village",
    "_stateSlug": "fl",
    "_citySlug": "jacksonville"
  },
  {
    "multihub_property_id": "5679206272860160",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Aidan",
    "property_slug": "the-aidan",
    "property_address": "165 Forestbrook Dr",
    "property_address_1": "165 Forestbrook Dr",
    "property_address_city": "Lewisville",
    "property_address_state": "TX",
    "property_address_zip": "75067",
    "property_address_latitude": "33.0070349",
    "property_address_longitude": "-96.9918854",
    "property_phone": "(972) 459-7550",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e89c3-b2d4-702f-9a9b-0df70105ff47.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5679206272860160/019e705d-b824-75db-bcbb-472b640671b9.webp",
    "property_primary_color": "#3c6275",
    "property_price_range": "1314.33 - 2010",
    "property_price_min": "1314.33",
    "property_price_max": "2010",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "584 - 1231",
    "property_short_description": "<p><strong>Newly renovated Lewisville apartments with DFW access made easy.</strong> Explore one, two, and three bedroom homes with granite kitchens, wood-style flooring, walk-in closets, and private outdoor space—then compare floor plans or schedule your tour at The Aidan.</p>",
    "property_type": "apartment",
    "property_total_units": "232",
    "property_website_url": "https://www.theaidanapts.com",
    "property_domain": "https://www.theaidanapts.com",
    "property_company_name": "American Landmark",
    "_slug": "the-aidan",
    "_stateSlug": "tx",
    "_citySlug": "lewisville"
  },
  {
    "multihub_property_id": "5697689396183040",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Access",
    "property_slug": "the-access",
    "property_address": "1811 E Apache Blvd",
    "property_address_1": "1811 E Apache Blvd",
    "property_address_city": "Tempe",
    "property_address_state": "AZ",
    "property_address_zip": "85281",
    "property_address_latitude": "33.41418790000001",
    "property_address_longitude": "-111.9086529",
    "property_phone": "(480) 966-0122",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-1512-770b-a5ca-2ebbe0f020f8.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-01d6-73ad-8dc8-c4113cf3aa1f.webp",
    "property_primary_color": "#24338a",
    "property_price_range": "1097.66 - 2640.16",
    "property_price_min": "1097.66",
    "property_price_max": "2640.16",
    "property_bedrooms_range": "studio - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "485 - 1199",
    "property_short_description": "<p><strong>Connected Tempe living starts at The Access.</strong> Set along the Apache Boulevard corridor, these studio to three-bedroom apartments pair polished in-home finishes with energizing community spaces and easy access across Tempe.</p>",
    "property_type": "apartment",
    "property_total_units": "408",
    "property_website_url": "https://www.liveattheaccess.com/",
    "property_domain": "https://www.liveattheaccess.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-access",
    "_stateSlug": "az",
    "_citySlug": "tempe"
  },
  {
    "multihub_property_id": "5745554927648768",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Asher",
    "property_slug": "the-asher",
    "property_address": "1949 Cove Lake Rd",
    "property_address_1": "1949 Cove Lake Rd",
    "property_address_city": "North Lauderdale",
    "property_address_state": "FL",
    "property_address_zip": "33068",
    "property_address_latitude": "26.2039257",
    "property_address_longitude": "-80.1958983",
    "property_phone": "(954) 972-6002",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-482d-7593-b9e0-90f34e9292aa.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e7062-9580-721e-8573-1b708c53b564.webp",
    "property_primary_color": "#5d643a",
    "property_price_range": "1967.5 - 3225",
    "property_price_min": "1967.5",
    "property_price_max": "3225",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "760 - 1238",
    "property_short_description": "<p><strong>Lakefront calm, everyday convenience.</strong> Discover pet-friendly one-, two-, and three-bedroom apartments with modern finishes, relaxed outdoor space, and resort-style perks—then explore <a href=\"/floor-plans\">spacious floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> at The Asher.</p>",
    "property_type": "apartment",
    "property_total_units": "224",
    "property_website_url": "https://www.liveattheasher.com/",
    "property_domain": "https://www.liveattheasher.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-asher",
    "_stateSlug": "fl",
    "_citySlug": "north-lauderdale"
  },
  {
    "multihub_property_id": "5632332274860032",
    "multihub_company_id": "5695708787113984",
    "property_name": "Royal Palms",
    "property_slug": "royal-palms",
    "property_address": "16100 Henderson Pass",
    "property_address_1": "16100 Henderson Pass",
    "property_address_city": "San Antonio",
    "property_address_state": "TX",
    "property_address_zip": "78232",
    "property_address_latitude": "29.5881802",
    "property_address_longitude": "-98.4475562",
    "property_phone": "(210) 809-4611",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5632332274860032/019d02ed-dd6b-7183-9f6e-29e6af9a079d.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5632332274860032/019e7018-2ade-75fa-8a97-43da8b0cf4c5.webp",
    "property_primary_color": "#1c346c",
    "property_price_range": "831.66 - 1257.83",
    "property_price_min": "831.66",
    "property_price_max": "1257.83",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "561 - 992",
    "property_short_description": "<p><strong>Modern comfort in north-central San Antonio.</strong> Explore one- and two-bedroom apartments with granite countertops, stainless steel appliances, walk-in closets, and private patios or balconies—then schedule your tour of Royal Palms today.</p>",
    "property_type": "apartment",
    "property_total_units": "244",
    "property_website_url": "https://www.royalpalmstx.com/",
    "property_domain": "https://www.royalpalmstx.com/",
    "property_company_name": "American Landmark",
    "_slug": "royal-palms",
    "_stateSlug": "tx",
    "_citySlug": "san-antonio"
  },
  {
    "multihub_property_id": "5706772312489984",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Bellamy",
    "property_slug": "the-bellamy",
    "property_address": "10015 Parthenon Ct",
    "property_address_1": "10015 Parthenon Ct",
    "property_address_city": "Charlotte",
    "property_address_state": "NC",
    "property_address_zip": "28262",
    "property_address_latitude": "35.3267957",
    "property_address_longitude": "-80.7431768",
    "property_phone": "(704) 971-4100",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-fe44-75fa-a340-cb7a05a192da.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f1-2b7b-7438-9020-443d63cb75e8.webp",
    "property_primary_color": "#3a3834",
    "property_price_range": "1342.16 - 2279.16",
    "property_price_min": "1342.16",
    "property_price_max": "2279.16",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1.5 - 2",
    "property_bathrooms_min": "1.5",
    "property_bathrooms_max": "2",
    "property_sqft_range": "1014 - 1416",
    "property_short_description": "<p><strong>Room to settle into University City.</strong> The Bellamy pairs spacious one-, two-, and three-bedroom apartments with polished everyday finishes and easy community comforts—ready to see what feels like home?</p>",
    "property_type": "apartment",
    "property_total_units": "279",
    "property_website_url": "https://www.liveatthebellamy.com/",
    "property_domain": "https://www.liveatthebellamy.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-bellamy",
    "_stateSlug": "nc",
    "_citySlug": "charlotte"
  },
  {
    "multihub_property_id": "5071683215949824",
    "multihub_company_id": "5695708787113984",
    "property_name": "Shelby at Northside",
    "property_slug": "shelby-at-northside",
    "property_address": "1852 E Northside Dr",
    "property_address_1": "1852 E Northside Dr",
    "property_address_city": "Fort Worth",
    "property_address_state": "TX",
    "property_address_zip": "76106",
    "property_address_latitude": "32.7815576",
    "property_address_longitude": "-97.3225798",
    "property_phone": "(817) 631-3676",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5071683215949824/019e89af-8421-76ab-8201-295329a63297.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5071683215949824/019e7024-abf5-7654-95d5-e09a727f885d.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1248.33 - 2869.16",
    "property_price_min": "1248.33",
    "property_price_max": "2869.16",
    "property_bedrooms_range": "studio - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 3",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "3",
    "property_sqft_range": "594 - 1606",
    "property_short_description": "<p><strong>Modern Fort Worth living with Stockyards energy close by.</strong> Discover studio to three-bedroom apartments with polished finishes, resort-style spaces, and a connected Northside location—then schedule your tour and find your next home base at Shelby at Northside.</p>",
    "property_type": "apartment",
    "property_total_units": "300",
    "property_website_url": "https://www.shelbyatnorthside.com/",
    "property_domain": "https://www.shelbyatnorthside.com/",
    "property_company_name": "American Landmark",
    "_slug": "shelby-at-northside",
    "_stateSlug": "tx",
    "_citySlug": "fort-worth"
  },
  {
    "multihub_property_id": "5745879600332800",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Bentley at Marietta",
    "property_slug": "the-bentley-at-marietta",
    "property_address": "880 S Cobb Dr SE",
    "property_address_1": "880 S Cobb Dr SE",
    "property_address_city": "Marietta",
    "property_address_state": "GA",
    "property_address_zip": "30060",
    "property_address_latitude": "33.932579",
    "property_address_longitude": "-84.5518665",
    "property_phone": "(770) 427-2157",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019d02f3-4589-7678-880f-2c187914aeea.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745879600332800/019e7069-6aa6-7609-9b6e-42872f8866e0.webp",
    "property_primary_color": "#6ea4dd",
    "property_price_range": "1190 - 1622.66",
    "property_price_min": "1190",
    "property_price_max": "1622.66",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "800 - 1200",
    "property_short_description": "<p><strong>Lakefront calm meets Marietta convenience.</strong> Explore spacious one- and two-bedroom apartments with renovated finishes, walk-in closets, and select sunrooms—then view <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Bentley at Marietta in person.</p>",
    "property_type": "apartment",
    "property_total_units": "222",
    "property_website_url": "https://www.thebentleyatmarietta.com/",
    "property_domain": "https://www.thebentleyatmarietta.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-bentley-at-marietta",
    "_stateSlug": "ga",
    "_citySlug": "marietta"
  },
  {
    "multihub_property_id": "5687098786971648",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Braxton",
    "property_slug": "the-braxton",
    "property_address": "1000 Palm Place Dr NE",
    "property_address_1": "1000 Palm Pl Dr NE",
    "property_address_city": "Palm Bay",
    "property_address_state": "FL",
    "property_address_zip": "32905",
    "property_address_latitude": "28.0301462",
    "property_address_longitude": "-80.61950949999999",
    "property_phone": "(321) 984-4440",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5687098786971648/019d02f0-618e-77c0-8ed8-ef402c6c4468.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5687098786971648/019e706c-117a-757a-96eb-56ee705b086a.webp",
    "property_primary_color": "#0b9444",
    "property_price_range": "1271.16 - 2063.66",
    "property_price_min": "1271.16",
    "property_price_max": "2063.66",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "595 - 1356",
    "property_short_description": "<p><strong>Coastal Palm Bay living, polished for every day.</strong> Explore one-, two-, and three-bedroom apartments with granite countertops, stainless steel appliances, walk-in closets, and select patios or balconies—then tour resort-style spaces designed for easy downtime at The Braxton.</p>",
    "property_type": "apartment",
    "property_total_units": "320",
    "property_website_url": "https://www.thebraxtonapts.com/",
    "property_domain": "https://www.thebraxtonapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-braxton",
    "_stateSlug": "fl",
    "_citySlug": "palm-bay"
  },
  {
    "multihub_property_id": "5638944016302080",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Elliott",
    "property_slug": "the-elliott",
    "property_address": "4600 Mba Ct",
    "property_address_1": "4600 Mba Ct",
    "property_address_city": "Concord",
    "property_address_state": "NC",
    "property_address_zip": "28027",
    "property_address_latitude": "35.4421414",
    "property_address_longitude": "-80.6573502",
    "property_phone": "(704) 793-1332",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ee-e459-7656-bcd7-f685ee24f2d9.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5638944016302080/019d02ee-a19f-73d2-9fb8-3e14f2c8073d.webp",
    "property_primary_color": "#6d3844",
    "property_price_range": "1357.83 - 2117.33",
    "property_price_min": "1357.83",
    "property_price_max": "2117.33",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "851 - 1485",
    "property_short_description": "<p><strong>Concord convenience with room to live well.</strong> Discover one-, two-, and three-bedroom apartments with polished finishes, everyday comforts, and easy access to I-85 and Concord Mills—then explore spacious floor plans or schedule your tour.</p>",
    "property_type": "apartment",
    "property_total_units": "240",
    "property_website_url": "https://www.theelliottnc.com/",
    "property_domain": "https://www.theelliottnc.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-elliott",
    "_stateSlug": "nc",
    "_citySlug": "concord"
  },
  {
    "multihub_property_id": "5108405723201536",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Elysian",
    "property_slug": "the-elysian",
    "property_address": "65 Sentosa Dr",
    "property_address_1": "65 Sentosa Dr",
    "property_address_city": "St Johns",
    "property_address_state": "FL",
    "property_address_zip": "32259",
    "property_address_latitude": "30.0764216",
    "property_address_longitude": "-81.4861303",
    "property_phone": "(904) 907-7225",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5108405723201536/019fb43e-32af-7385-b65a-213dfb5420ad.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5108405723201536/019e7077-5475-71af-a46d-27f77f513a44.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1413 - 2549",
    "property_price_min": "1413",
    "property_price_max": "2549",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "624 - 1322",
    "property_short_description": "<p><strong>Resort-style St Johns living starts at The Elysian.</strong> Explore one-, two-, and three-bedroom apartments in Beachwalk with polished interiors, smart-home features, and access to the 14-acre Crystal Lagoon—then schedule your tour.</p>",
    "property_type": "apartment",
    "property_total_units": "348",
    "property_website_url": "https://www.lifeatelysian.com/",
    "property_domain": "https://www.lifeatelysian.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-elysian",
    "_stateSlug": "fl",
    "_citySlug": "st-johns"
  },
  {
    "multihub_property_id": "6217674912694272",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Everette at East Cobb",
    "property_slug": "the-everette-at-east-cobb",
    "property_address": "1675 Roswell Rd",
    "property_address_1": "1675 Roswell Rd",
    "property_address_city": "Marietta",
    "property_address_state": "GA",
    "property_address_zip": "30062",
    "property_address_latitude": "33.9566766",
    "property_address_longitude": "-84.5051069",
    "property_phone": "(770) 977-3780",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6217674912694272/019d02f6-8bc8-72cc-8339-975cb69ca68d.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6217674912694272/019e707a-4ea4-74b9-be5e-4dc029fca300.webp",
    "property_primary_color": "#f4b334",
    "property_price_range": "1249.13 - 2225.7",
    "property_price_min": "1249.13",
    "property_price_max": "2225.7",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "715 - 1425",
    "property_short_description": "<p><strong>East Cobb ease meets everyday resort-style comfort</strong> at The Everette, with spacious one-, two-, and three-bedroom apartments featuring polished finishes and relaxed indoor-outdoor living. Explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
    "property_type": "apartment",
    "property_total_units": "312",
    "property_website_url": "https://www.theeveretteapts.com/",
    "property_domain": "https://www.theeveretteapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-everette-at-east-cobb",
    "_stateSlug": "ga",
    "_citySlug": "marietta"
  },
  {
    "multihub_property_id": "5760835792142336",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Franklin at East Cobb",
    "property_slug": "the-franklin-at-east-cobb",
    "property_address": "875 Franklin Gtwy SE",
    "property_address_1": "875 Franklin Gateway SE",
    "property_address_city": "Marietta",
    "property_address_state": "GA",
    "property_address_zip": "30067",
    "property_address_latitude": "33.9319972",
    "property_address_longitude": "-84.4970512",
    "property_phone": "(770) 424-6170",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5760835792142336/019d02f4-7f00-70d6-89df-d399304dfdb1.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5760835792142336/019e73ce-ed45-73c8-9dc7-beec136dbfe0.webp",
    "property_primary_color": "#4b4b4b",
    "property_price_range": "1152.5 - 1917",
    "property_price_min": "1152.5",
    "property_price_max": "1917",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "715 - 1425",
    "property_short_description": "<p><strong>Modern Marietta living with East Cobb access.</strong> Find renovated one-, two-, and three-bedroom apartments with open layouts, stainless steel appliances, wood-style flooring, and select private patios or balconies—then schedule a tour to see The Franklin at East Cobb in person.</p>",
    "property_type": "apartment",
    "property_total_units": "380",
    "property_website_url": "https://www.thefranklinapts.com",
    "property_domain": "https://www.thefranklinapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-franklin-at-east-cobb",
    "_stateSlug": "ga",
    "_citySlug": "marietta"
  },
  {
    "multihub_property_id": "5749591836196864",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Edge",
    "property_slug": "the-edge",
    "property_address": "3833 Manson Pike",
    "property_address_1": "3833 Manson Pike",
    "property_address_city": "Murfreesboro",
    "property_address_state": "TN",
    "property_address_zip": "37129",
    "property_address_latitude": "35.8696907",
    "property_address_longitude": "-86.4712198",
    "property_phone": "(615) 802-9550",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5749591836196864/019d02f3-8535-741e-b404-17e5cfcad38c.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5749591836196864/019e7072-9ae6-77f9-b45e-aa15b755dc06.webp",
    "property_primary_color": "#b11957",
    "property_price_range": "1318.33 - 2255",
    "property_price_min": "1318.33",
    "property_price_max": "2255",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "617 - 1151",
    "property_short_description": "<p><strong>Modern Murfreesboro living with everyday momentum.</strong> Find one-, two-, and three-bedroom apartments with quartz countertops, stainless steel appliances, and in-home laundry, plus polished community spaces that make daily life easier. Choose your layout and schedule a tour at The Edge.</p>",
    "property_type": "apartment",
    "property_total_units": "288",
    "property_website_url": "https://www.theedgetn.com/",
    "property_domain": "https://www.theedgetn.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-edge",
    "_stateSlug": "tn",
    "_citySlug": "murfreesboro"
  },
  {
    "multihub_property_id": "5164807904821248",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Harrison at Windsor Hill",
    "property_slug": "the-harrison-at-windsor-hill",
    "property_address": "8240 Windsor Hill Blvd",
    "property_address_1": "8240 Windsor Hill Blvd",
    "property_address_city": "North Charleston",
    "property_address_state": "SC",
    "property_address_zip": "29420",
    "property_address_latitude": "32.9287282",
    "property_address_longitude": "-80.0932996",
    "property_phone": "(843) 767-2020",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5164807904821248/019d02ed-f1e8-7574-86b1-ecee26ae3e5a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5164807904821248/019e73d7-814a-729c-aa78-83f7e29b6916.webp",
    "property_primary_color": "#1e2a28",
    "property_price_range": "1463.16 - 1795",
    "property_price_min": "1463.16",
    "property_price_max": "1795",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "788 - 1007",
    "property_short_description": "<p><strong>Modern comfort in Windsor Hill.</strong> Explore spacious one- and two-bedroom apartments with open layouts, granite countertops, wood-style flooring, walk-in closets, and private outdoor space—then schedule your tour to see The Harrison at Windsor Hill up close.</p>",
    "property_type": "apartment",
    "property_total_units": "312",
    "property_website_url": "https://www.theharrisonlifestyle.com/",
    "property_domain": "https://www.theharrisonlifestyle.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-harrison-at-windsor-hill",
    "_stateSlug": "sc",
    "_citySlug": "north-charleston"
  },
  {
    "multihub_property_id": "5642466493464576",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Isaac",
    "property_slug": "the-isaac",
    "property_address": "195 N Creek Dr",
    "property_address_1": "195 N Creek Dr",
    "property_address_city": "Summerville",
    "property_address_state": "SC",
    "property_address_zip": "29486",
    "property_address_latitude": "33.1000894",
    "property_address_longitude": "-80.1320416",
    "property_phone": "(843) 482-1903",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5642466493464576/019d02ee-cc08-71d6-8209-ebfc703bdad3.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5642466493464576/019e73df-a91a-77ba-bbe8-e47633cd70e5.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1422.16 - 2197.5",
    "property_price_min": "1422.16",
    "property_price_max": "2197.5",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "688 - 1433",
    "property_short_description": "<p><strong>Lowcountry ease, polished apartment living.</strong> The Isaac pairs open one-, two-, and three-bedroom homes with quartz countertops, stainless steel appliances, walk-in closets, and private outdoor space—all in a connected Summerville setting with quick access to everyday conveniences. Schedule a tour to see it in person.</p>",
    "property_type": "apartment",
    "property_total_units": "264",
    "property_website_url": "https://www.theisaacsummerville.com/",
    "property_domain": "https://www.theisaacsummerville.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-isaac",
    "_stateSlug": "sc",
    "_citySlug": "summerville"
  },
  {
    "multihub_property_id": "5738013569056768",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Legend",
    "property_slug": "the-legend",
    "property_address": "8797 Marbach Rd",
    "property_address_1": "8797 Marbach Rd",
    "property_address_city": "San Antonio",
    "property_address_state": "TX",
    "property_address_zip": "78227",
    "property_address_latitude": "29.4189055",
    "property_address_longitude": "-98.6595584",
    "property_phone": "(210) 673-5502",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019d02f3-564c-703f-b796-e1e38f3d6a30.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019d02f3-42a0-72ee-8b68-17c2e0428c73.webp",
    "property_primary_color": "#244c5a",
    "property_price_range": "883.83 - 1555",
    "property_price_min": "883.83",
    "property_price_max": "1555",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "499 - 1150",
    "property_short_description": "<p><strong>Live connected on San Antonio’s Far West Side.</strong> The Legend pairs one, two, and three bedroom apartments with comfortable finishes, inviting community spaces, and quick access to major routes—<a href=\"/schedule-a-tour\">schedule a tour</a> to see it all in person.</p>",
    "property_type": "apartment",
    "property_total_units": "480",
    "property_website_url": "https://www.thelegendtexas.com",
    "property_domain": "https://www.thelegendtexas.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-legend",
    "_stateSlug": "tx",
    "_citySlug": "san-antonio"
  },
  {
    "multihub_property_id": "5753550520975360",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Jaxon",
    "property_slug": "the-jaxon",
    "property_address": "4855 Magnolia Cove Dr",
    "property_address_1": "4855 Magnolia Cove Dr",
    "property_address_city": "Houston",
    "property_address_state": "TX",
    "property_address_zip": "77345",
    "property_address_latitude": "30.0344935",
    "property_address_longitude": "-95.17287189999999",
    "property_phone": "(281) 360-0896",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753550520975360/019d02f5-7ce9-72af-ac2a-eb4a690dfed8.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5753550520975360/019e73e1-f9ca-705d-a804-0598c4a6637d.webp",
    "property_primary_color": "#ee811b",
    "property_price_range": "1136.66 - 2080",
    "property_price_min": "1136.66",
    "property_price_max": "2080",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "687 - 1414",
    "property_short_description": "<p><strong>Polished Kingwood comfort near Lake Houston.</strong> Explore renovated one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with quartz counters, modern cabinetry, deep-soaking tubs, and private patios or balconies in select homes—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Jaxon in person.</p>",
    "property_type": "apartment",
    "property_total_units": "250",
    "property_website_url": "https://www.thejaxonhouston.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-jaxon",
    "_stateSlug": "tx",
    "_citySlug": "houston"
  },
  {
    "multihub_property_id": "5662505695182848",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Lotus",
    "property_slug": "the-lotus",
    "property_address": "10000 W Missouri Ave",
    "property_address_1": "10000 W Missouri Ave",
    "property_address_city": "Glendale",
    "property_address_state": "AZ",
    "property_address_zip": "85307",
    "property_address_latitude": "33.5167503",
    "property_address_longitude": "-112.2760309",
    "property_phone": "(602) 428-2234",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5662505695182848/019d02ef-d46f-7031-8394-0b16dec068de.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5662505695182848/019d02ef-9350-770c-8dd5-a90d9545c0c5.webp",
    "property_primary_color": "#3b5b56",
    "property_price_range": "1115.66 - 1555",
    "property_price_min": "1115.66",
    "property_price_max": "1555",
    "property_bedrooms_range": "studio - 2",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "468 - 828",
    "property_short_description": "<p><strong>Modern Westside Glendale living, made easy.</strong> The Lotus pairs bright studio, one-, and two-bedroom <a href=\"/floor-plans\">floor plans</a> with polished finishes, relaxing indoor-outdoor spaces, and everyday conveniences. Explore the <a href=\"/amenities\">amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the calm, contemporary style in person.</p>",
    "property_type": "apartment",
    "property_total_units": "286",
    "property_website_url": "https://www.thelotusapts.com/",
    "property_domain": "https://www.thelotusapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-lotus",
    "_stateSlug": "az",
    "_citySlug": "glendale"
  },
  {
    "multihub_property_id": "5714777124896768",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Lynx",
    "property_slug": "the-lynx",
    "property_address": "6000 Randolph Blvd",
    "property_address_1": "6000 Randolph Blvd",
    "property_address_city": "San Antonio",
    "property_address_state": "TX",
    "property_address_zip": "78233",
    "property_address_latitude": "29.5408635",
    "property_address_longitude": "-98.3662243",
    "property_phone": "(210) 655-1806",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5714777124896768/019d02f1-bd58-76bf-b70f-2be9ac9211f1.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5714777124896768/019e73ee-7dcc-73b9-aa37-2870e797b0e6.webp",
    "property_primary_color": "#935023",
    "property_price_range": "775.83 - 1493",
    "property_price_min": "775.83",
    "property_price_max": "1493",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "400 - 1125",
    "property_short_description": "<p><strong>Find your rhythm at The Lynx.</strong> Explore one-, two-, and three-bedroom apartments in Northeast San Antonio with stylish finishes, everyday conveniences, and community spaces made for relaxing, recharging, and getting more out of home.</p>",
    "property_type": "apartment",
    "property_total_units": "552",
    "property_website_url": "https://www.thelynxliving.com",
    "property_domain": "https://www.thelynxliving.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-lynx",
    "_stateSlug": "tx",
    "_citySlug": "san-antonio"
  },
  {
    "multihub_property_id": "5675057267343360",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Mason",
    "property_slug": "the-mason",
    "property_address": "1110 Mason Pond Pl",
    "property_address_1": "1110 Mason Pond Pl",
    "property_address_city": "Ladson",
    "property_address_state": "SC",
    "property_address_zip": "29456",
    "property_address_latitude": "32.9992435",
    "property_address_longitude": "-80.11861189999999",
    "property_phone": "(843) 608-0138",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019d02f0-c92b-764f-bb71-2ed4fa4f4a66.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e73f1-0624-73ae-88f0-9e456457087f.webp",
    "property_primary_color": "#0a3b61",
    "property_price_range": "1392.66 - 2470.66",
    "property_price_min": "1392.66",
    "property_price_max": "2470.66",
    "property_bedrooms_range": "studio - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "603 - 1331",
    "property_short_description": "<p><strong>Suburban ease with polished Lowcountry style.</strong> The Mason pairs studio to three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with elevated everyday finishes, relaxed community spaces, and a quieter Ladson setting near I-26 and US-78—close to Summerville energy and Charleston access.</p>",
    "property_type": "apartment",
    "property_total_units": "264",
    "property_website_url": "https://www.themasonsc.com/",
    "property_domain": "https://www.themasonsc.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-mason",
    "_stateSlug": "sc",
    "_citySlug": "ladson"
  },
  {
    "multihub_property_id": "5690269169090560",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Murray",
    "property_slug": "the-murray",
    "property_address": "8010 Woodsedge Dr",
    "property_address_1": "8010 Woodsedge Dr",
    "property_address_city": "Charlotte",
    "property_address_state": "NC",
    "property_address_zip": "28216",
    "property_address_latitude": "35.3470325",
    "property_address_longitude": "-80.8641971",
    "property_phone": "(704) 399-1159",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f1-1bdc-75d8-95c9-0fe61af74268.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e73f4-0486-749d-ba89-7e1ea49e1b97.webp",
    "property_primary_color": "#41693d",
    "property_price_range": "1501.66 - 1757.83",
    "property_price_min": "1501.66",
    "property_price_max": "1757.83",
    "property_bedrooms_range": "2 - 3",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "2 - 2",
    "property_bathrooms_min": "2",
    "property_bathrooms_max": "2",
    "property_sqft_range": "991 - 1113",
    "property_short_description": "<p><strong>Connected Northlake living with room to settle in.</strong> The Murray pairs spacious two- and three-bedroom layouts with polished finishes, smart home features, and easy-access community comforts in a Charlotte location built for streamlined everyday living.</p>",
    "property_type": "apartment",
    "property_total_units": "160",
    "property_website_url": "https://www.liveatthemurray.com/",
    "property_domain": "https://www.liveatthemurray.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-murray",
    "_stateSlug": "nc",
    "_citySlug": "charlotte"
  },
  {
    "multihub_property_id": "5075831726538752",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Regent",
    "property_slug": "the-regent",
    "property_address": "17717 Preston Rd",
    "property_address_1": "17717 Preston Rd",
    "property_address_city": "Dallas",
    "property_address_state": "TX",
    "property_address_zip": "75252",
    "property_address_latitude": "32.9954466",
    "property_address_longitude": "-96.80060519999999",
    "property_phone": "(972) 931-5902",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5075831726538752/019d02ee-1aa6-74d8-ab4d-41d521cab0c6.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5075831726538752/019e73fc-dfdc-7517-9434-e71232fecd09.webp",
    "property_primary_color": "#0076a9",
    "property_price_range": "1098.83 - 1893.33",
    "property_price_min": "1098.83",
    "property_price_max": "1893.33",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "575 - 1189",
    "property_short_description": "<p><strong>Resort-style ease in Far North Dallas.</strong> Explore updated one- and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> with polished finishes, relaxed outdoor space, and community amenities made for downtime—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Regent for yourself.</p>",
    "property_type": "apartment",
    "property_total_units": "460",
    "property_website_url": "https://www.theregentdallas.com/",
    "property_domain": "https://www.theregentdallas.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-regent",
    "_stateSlug": "tx",
    "_citySlug": "dallas"
  },
  {
    "multihub_property_id": "5110905058623488",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Pearl",
    "property_slug": "the-pearl",
    "property_address": "3880 W Broward Blvd",
    "property_address_1": "3880 W Broward Blvd",
    "property_address_city": "Fort Lauderdale",
    "property_address_state": "FL",
    "property_address_zip": "33312",
    "property_address_latitude": "26.1203376",
    "property_address_longitude": "-80.20044560000001",
    "property_phone": "(954) 583-7542",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5110905058623488/019e8a05-bf94-77d9-aede-ade0b71c0a63.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5110905058623488/019e73f6-7c11-706f-99a5-ec05d66ea90a.webp",
    "property_primary_color": "#0072a3",
    "property_price_range": "3001",
    "property_price_max": "3001",
    "property_bedrooms_range": "studio - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": " - 1330",
    "property_short_description": "<p><strong>Polished Plantation living, resort-inspired ease.</strong> Discover upgraded studio to three-bedroom apartments with select loft-style layouts, quartz countertops, stainless-steel appliances, in-home laundry, and everyday comforts—then schedule a tour to see The Pearl in person.</p>",
    "property_type": "apartment",
    "property_total_units": "231",
    "property_website_url": "https://www.thepearlliving.com/",
    "property_domain": "https://www.thepearlliving.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-pearl",
    "_stateSlug": "fl",
    "_citySlug": "fort-lauderdale"
  },
  {
    "multihub_property_id": "5647035332034560",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Tribute",
    "property_slug": "the-tribute",
    "property_address": "26325 Northgate Crossing Blvd",
    "property_address_1": "26325 Northgate Crossing Blvd",
    "property_address_city": "Spring",
    "property_address_state": "TX",
    "property_address_zip": "77373",
    "property_address_latitude": "30.1065509",
    "property_address_longitude": "-95.42897699999999",
    "property_phone": "(281) 651-6644",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019d02ef-ba8a-76d1-a055-f86049e32db4.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e7402-1d1d-76fb-99f7-8d3b90ffc14c.webp",
    "property_primary_color": "#0b3b4a",
    "property_price_range": "1038.5 - 1836.66",
    "property_price_min": "1038.5",
    "property_price_max": "1836.66",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "599 - 1234",
    "property_short_description": "<p><strong>Modern Spring apartments with room to unwind.</strong> The Tribute pairs polished one-, two-, and three-bedroom homes with resort-style community spaces in Northgate Crossing—compare <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
    "property_type": "apartment",
    "property_total_units": "248",
    "property_website_url": "https://www.liveatthetribute.com/",
    "property_domain": "https://www.liveatthetribute.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-tribute",
    "_stateSlug": "tx",
    "_citySlug": "spring"
  },
  {
    "multihub_property_id": "4810300029140992",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Kendall",
    "property_slug": "the-kendall",
    "property_address": "1101 Flagstone Ln",
    "property_address_1": "1101 Flagstone Ln",
    "property_address_city": "Indian Trail",
    "property_address_state": "NC",
    "property_address_zip": "28079",
    "property_address_latitude": "35.0725611",
    "property_address_longitude": "-80.6375202",
    "property_phone": "(704) 234-0444",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019d02ed-fdec-72b8-956d-fd712197dd91.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e73e4-1858-74c6-8bff-8dea3f3f11e6.webp",
    "property_primary_color": "#9b9647",
    "property_price_range": "1245 - 1835",
    "property_price_min": "1245",
    "property_price_max": "1835",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "724 - 1179",
    "property_short_description": "<p><strong>Modern comfort, Union County convenience.</strong> The Kendall pairs open one-, two-, and three-bedroom layouts with polished finishes and everyday extras in a connected Indian Trail setting. Explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
    "property_type": "apartment",
    "property_total_units": "252",
    "property_website_url": "https://www.lifeatthekendall.com/",
    "property_domain": "https://www.lifeatthekendall.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-kendall",
    "_stateSlug": "nc",
    "_citySlug": "indian-trail"
  },
  {
    "multihub_property_id": "5767160559304704",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Logan",
    "property_slug": "the-logan",
    "property_address": "1400 Sierra Springs Dr",
    "property_address_1": "1400 Sierra Springs Dr",
    "property_address_city": "Bedford",
    "property_address_state": "TX",
    "property_address_zip": "76021",
    "property_address_latitude": "32.8404679",
    "property_address_longitude": "-97.1468134",
    "property_phone": "(817) 540-4044",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019d02f4-cbae-73d3-815a-1e27e24948c2.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5767160559304704/019e73e8-21a0-76c0-920e-64d779301568.webp",
    "property_primary_color": "#006ba7",
    "property_price_range": "1120 - 1708.33",
    "property_price_min": "1120",
    "property_price_max": "1708.33",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "551 - 1105",
    "property_short_description": "<p><strong>Mid-Cities ease, polished everyday comfort.</strong> The Logan pairs one- and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> with granite kitchens, washer/dryer connections, and private patios or balconies—plus quick access across Bedford and the DFW area. <a href=\"/schedule-a-tour\">Schedule a tour</a> to see it in person.</p>",
    "property_type": "apartment",
    "property_total_units": "490",
    "property_website_url": "https://www.theloganapartments.com/",
    "property_domain": "https://www.theloganapartments.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-logan",
    "_stateSlug": "tx",
    "_citySlug": "bedford"
  },
  {
    "multihub_property_id": "5657559276978176",
    "multihub_company_id": "5695708787113984",
    "property_name": "The View at Lakeside",
    "property_slug": "the-view-at-lakeside",
    "property_address": "901 Lakeside Cir",
    "property_address_1": "901 Lakeside Cir",
    "property_address_city": "Lewisville",
    "property_address_state": "TX",
    "property_address_zip": "75057",
    "property_address_latitude": "33.0093197",
    "property_address_longitude": "-96.9618469",
    "property_phone": "(972) 315-6525",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-98a3-701c-be49-059d19abd67a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e7406-1362-72b8-9eb5-6d4b6f09f94a.webp",
    "property_primary_color": "#7a9c3e",
    "property_price_range": "1190 - 2195",
    "property_price_min": "1190",
    "property_price_max": "2195",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "675 - 1254",
    "property_short_description": "<p><strong>Lake-view calm with Metroplex momentum.</strong> The View at Lakeside brings gated, pet-friendly apartment living to Lewisville’s Lakeside area, with polished one-, two-, and three-bedroom homes and easy access to major DFW connections. Schedule a tour and see the view for yourself.</p>",
    "property_type": "apartment",
    "property_total_units": "360",
    "property_website_url": "https://www.theviewatlakeside.com/",
    "property_domain": "https://www.theviewatlakeside.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-view-at-lakeside",
    "_stateSlug": "tx",
    "_citySlug": "lewisville"
  },
  {
    "multihub_property_id": "5714278346653696",
    "multihub_company_id": "5695708787113984",
    "property_name": "Waterford Trails",
    "property_slug": "waterford-trails",
    "property_address": "21201 Emerald Mist Pkwy",
    "property_address_1": "21201 Emerald Mist Pkwy",
    "property_address_city": "Spring",
    "property_address_state": "TX",
    "property_address_zip": "77379",
    "property_address_latitude": "30.0692636",
    "property_address_longitude": "-95.5451697",
    "property_phone": "(281) 251-8800",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5714278346653696/019d02f1-94a0-77cf-bacb-bc6f40412687.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5714278346653696/019e7409-dc31-7550-b46a-6eee63b9d5f9.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1074 - 2215",
    "property_price_min": "1074",
    "property_price_max": "2215",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "590 - 1409",
    "property_short_description": "<p><strong>Modern North Spring living with room to unwind.</strong> Explore open one-, two-, and three-bedroom apartments with chef-inspired kitchens, granite countertops, walk-in closets, and private patios or balconies—then schedule your tour to see Waterford Trails in person.</p>",
    "property_type": "apartment",
    "property_total_units": "340",
    "property_website_url": "https://www.waterfordtrailsliving.com/",
    "property_domain": "https://www.waterfordtrailsliving.com/",
    "property_company_name": "American Landmark",
    "_slug": "waterford-trails",
    "_stateSlug": "tx",
    "_citySlug": "spring"
  },
  {
    "multihub_property_id": "5198384616964096",
    "multihub_company_id": "5695708787113984",
    "property_name": "Watersedge",
    "property_slug": "watersedge",
    "property_address": "1799 Fm 528 Rd",
    "property_address_1": "1799 FM 528 Rd",
    "property_address_city": "Webster",
    "property_address_state": "TX",
    "property_address_zip": "77598",
    "property_address_latitude": "29.5227947",
    "property_address_longitude": "-95.14046689999999",
    "property_phone": "(281) 554-4333",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-3536-716a-ade5-fe3823d7d81a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ed-d944-73ef-8c0e-de89e7cdb749.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1312.33 - 1978.33",
    "property_price_min": "1312.33",
    "property_price_max": "1978.33",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "650 - 1219",
    "property_short_description": "<p><strong>Lake-view living made easy in Webster.</strong> Settle into a one- or two-bedroom apartment with calm trails, lighted fountains, and inviting home finishes, then explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Watersedge in person.</p>",
    "property_type": "apartment",
    "property_total_units": "354",
    "property_website_url": "https://www.lifeatwatersedge.com/",
    "property_domain": "https://www.lifeatwatersedge.com/",
    "property_company_name": "American Landmark",
    "_slug": "watersedge",
    "_stateSlug": "tx",
    "_citySlug": "webster"
  },
  {
    "multihub_property_id": "5764347288616960",
    "multihub_company_id": "5695708787113984",
    "property_name": "Westwood Terrace",
    "property_slug": "westwood-terrace",
    "property_address": "11139 Culebra Rd",
    "property_address_1": "11139 Culebra Rd",
    "property_address_city": "San Antonio",
    "property_address_state": "TX",
    "property_address_zip": "78253",
    "property_address_latitude": "29.4991321",
    "property_address_longitude": "-98.7119869",
    "property_phone": "(210) 688-9444",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019d02f5-2509-749f-990d-fe7a094ba728.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a1f-14aa-7249-bd30-3f5800f34114.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1021.33 - 1475",
    "property_price_min": "1021.33",
    "property_price_max": "1475",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "499 - 937",
    "property_short_description": "<p><strong>Modern Far West Side living starts here.</strong> Explore one- and two-bedroom apartments with granite countertops, stainless steel appliances, hardwood-style flooring, and everyday convenience near Culebra Road and Loop 1604—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Westwood Terrace in person.</p>",
    "property_type": "apartment",
    "property_total_units": "204",
    "property_website_url": "https://www.westwoodterraceliving.com/",
    "property_domain": "https://www.westwoodterraceliving.com/",
    "property_company_name": "American Landmark",
    "_slug": "westwood-terrace",
    "_stateSlug": "tx",
    "_citySlug": "san-antonio"
  },
  {
    "multihub_property_id": "5691698319458304",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Reve",
    "property_slug": "the-reve",
    "property_address": "6310 Naaman Forest Blvd",
    "property_address_1": "6310 Naaman Forest Blvd",
    "property_address_city": "Garland",
    "property_address_state": "TX",
    "property_address_zip": "75044",
    "property_address_latitude": "32.9721207",
    "property_address_longitude": "-96.6573002",
    "property_phone": "(469) 613-5200",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5691698319458304/019d02f1-20c6-74c9-919f-51fef7890aab.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5691698319458304/019e73ff-a95c-75c1-b3ae-46454342bb91.webp",
    "property_primary_color": "#000000",
    "property_price_range": "2411.5",
    "property_price_min": "1387",
    "property_price_max": "2411.5",
    "property_bedrooms_range": "studio - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 3",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "3",
    "property_sqft_range": "663 - 1476",
    "property_short_description": "<p><strong>Modern Garland apartments with nature at the edge.</strong> Discover studio to three-bedroom <a href=\"/floor-plans\">floor plans</a> with polished finishes, in-home conveniences, and community spaces designed for an easy everyday rhythm near Spring Creek Forest Preserve.</p>",
    "property_type": "apartment",
    "property_total_units": "225",
    "property_website_url": "https://www.thereveapts.com/",
    "property_domain": "https://www.thereveapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-reve",
    "_stateSlug": "tx",
    "_citySlug": "garland"
  },
  {
    "multihub_property_id": "6737460151191281",
    "multihub_company_id": "5695708787113984",
    "property_name": "Adley Luxe",
    "property_slug": "adley-luxe",
    "property_address": "665 Starratt Road",
    "property_address_1": "665 Starratt Rd",
    "property_address_city": "Jacksonville",
    "property_address_state": "FL",
    "property_address_zip": "32218",
    "property_address_latitude": "30.474487",
    "property_address_longitude": "-81.61197899999999",
    "property_phone": "904-977-3766",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191281/019f8b69-1d9a-731b-8d0e-8401717c1455.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191281/019f8b69-a077-72e1-9613-d28400dda77d.webp",
    "property_primary_color": "#2b5169",
    "property_price_range": " - ",
    "property_total_units": "200",
    "property_website_url": "https://www.adleyluxe.com/",
    "property_domain": "https://www.adleyluxe.com/",
    "property_company_name": "American Landmark",
    "_slug": "adley-luxe",
    "_stateSlug": "fl",
    "_citySlug": "jacksonville"
  },
  {
    "multihub_property_id": "6737460151191297",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Drake at Deerwood",
    "property_slug": "the-drake-at-deerwood",
    "property_address": "9727 Touchton Rd",
    "property_address_1": "9727 Touchton Rd",
    "property_address_city": "Jacksonville",
    "property_address_state": "FL",
    "property_address_zip": "32246",
    "property_address_latitude": "30.26983",
    "property_address_longitude": "-81.5543323",
    "property_phone": "(904) 374-2000",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019d02f5-a8fe-76de-86ef-34c6145de92f.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191297/019e706f-e70c-70e1-8ee4-c04c245849b5.webp",
    "property_primary_color": "#0a4975",
    "property_price_range": "1204 - 2140",
    "property_price_min": "1204",
    "property_price_max": "2140",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "559 - 1390",
    "property_short_description": "<p><strong>Southside convenience with a polished Deerwood feel.</strong> Discover one-, two-, and three-bedroom apartments with chef-style kitchens, granite countertops, wood-style flooring, screened porches, and spaces designed for easy downtime—then schedule a tour to see The Drake at Deerwood in person.</p>",
    "property_type": "apartment",
    "property_total_units": "322",
    "property_website_url": "https://www.lifeatthedrake.com/",
    "property_domain": "https://www.lifeatthedrake.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-drake-at-deerwood",
    "_stateSlug": "fl",
    "_citySlug": "jacksonville"
  },
  {
    "multihub_property_id": "6737460151192580",
    "multihub_company_id": "5695708787113984",
    "property_name": "Electra Capital",
    "property_slug": "electra-capital",
    "property_address": "1331 South Killian Drive, Suite A",
    "property_address_city": "Lake Park",
    "property_address_state": "Florida ",
    "property_address_zip": "33403",
    "property_phone": "561-408-3442",
    "property_website_url": "http://electracapital.com",
    "property_company_name": "American Landmark",
    "_slug": "electra-capital",
    "_stateSlug": "florida",
    "_citySlug": "lake-park"
  },
  {
    "multihub_property_id": "6737460151194273",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Pointe on Westshore",
    "property_slug": "the-pointe-on-westshore",
    "property_address": "4950 W Prescott St",
    "property_address_1": "4950 W Prescott St",
    "property_address_city": "Tampa",
    "property_address_state": "FL",
    "property_address_zip": "33616",
    "property_address_latitude": "27.8664524",
    "property_address_longitude": "-82.5297447",
    "property_phone": "(813) 694-7990",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151194273/019d02f6-11ee-7648-9b11-c802760a56d7.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151194273/019e73fa-0fa8-76ca-9617-4e8302d82a12.webp",
    "property_primary_color": "#5ba1a2",
    "property_price_range": "1890.16 - 3375.33",
    "property_price_min": "1890.16",
    "property_price_max": "3375.33",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "687 - 1469",
    "property_short_description": "<p><strong>Bay-view apartment living with South Tampa ease.</strong> Explore one-, two-, and three-bedroom homes with modern finishes, plus coastal-inspired spaces designed for everyday comfort—then view <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> of The Pointe on Westshore.</p>",
    "property_type": "apartment",
    "property_total_units": "444",
    "property_website_url": "https://www.thepointeonwestshore.com/",
    "property_domain": "https://www.thepointeonwestshore.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-pointe-on-westshore",
    "_stateSlug": "fl",
    "_citySlug": "tampa"
  },
  {
    "multihub_property_id": "6767906449163362",
    "multihub_company_id": "5695708787113984",
    "property_name": "Jameson",
    "property_slug": "jameson",
    "property_address": "255 Williamsburg Pkwy",
    "property_address_1": "255 Williamsburg Pkwy",
    "property_address_city": "Fate",
    "property_address_state": "TX",
    "property_address_zip": "75189",
    "property_address_latitude": "32.9264051",
    "property_address_longitude": "-96.3802731",
    "property_phone": "(469) 707-4646",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163362/019d02f6-e9b5-75fd-bd13-81596d0f387a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163362/019e6aae-c973-728a-88cf-747dd48207b5.webp",
    "property_primary_color": "#797c60",
    "property_price_range": "1417.5 - 2122.66",
    "property_price_min": "1417.5",
    "property_price_max": "2122.66",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "731 - 1191",
    "property_short_description": "<p><strong>Modern Fate living with room to settle in.</strong> Discover polished one- and two-bedroom apartments with open layouts, smart finishes, and easy community comforts near I-30—then schedule your tour of Jameson today.</p>",
    "property_type": "apartment",
    "property_total_units": "366",
    "property_website_url": "https://www.lifeatjameson.com/",
    "property_domain": "https://www.lifeatjameson.com/",
    "property_company_name": "American Landmark",
    "_slug": "jameson",
    "_stateSlug": "tx",
    "_citySlug": "fate"
  },
  {
    "multihub_property_id": "6767906449163003",
    "multihub_company_id": "5695708787113984",
    "property_name": "Sage at Ingleside",
    "property_slug": "sage-at-ingleside",
    "property_address": "9345 Blue House Rd",
    "property_address_1": "9345 Blue House Rd",
    "property_address_city": "Ladson",
    "property_address_state": "SC",
    "property_address_zip": "29456",
    "property_address_latitude": "32.9739499",
    "property_address_longitude": "-80.0789851",
    "property_phone": "(843) 225-4675",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163003/019e89ad-bd8c-73af-94a9-b6928a9b50de.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163003/019e701c-39a1-70e8-9b4f-72d9eb32ab34.webp",
    "property_primary_color": "#3e4938",
    "property_price_range": "1469.66 - 2446.83",
    "property_price_min": "1469.66",
    "property_price_max": "2446.83",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "743 - 1471",
    "property_short_description": "<p><strong>Modern comfort in the Ingleside corridor.</strong> Explore polished studio to three-bedroom <a href=\"/floor-plans\">floor plans</a> with stylish finishes, smart-home details, and resort-inspired spaces that make daily living feel easy—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Sage at Ingleside up close.</p>",
    "property_type": "apartment",
    "property_total_units": "304",
    "property_website_url": "https://www.sageatingleside.com/",
    "property_domain": "https://www.sageatingleside.com/",
    "property_company_name": "American Landmark",
    "_slug": "sage-at-ingleside",
    "_stateSlug": "sc",
    "_citySlug": "ladson"
  },
  {
    "multihub_property_id": "6767906449163351",
    "multihub_company_id": "5695708787113984",
    "property_name": "Eightyone10 Blue Goose",
    "property_slug": "eightyone10-blue-goose",
    "property_address": "8110 Blue Goose Rd",
    "property_address_1": "8110 Blue Goose Rd",
    "property_address_city": "Manor",
    "property_address_state": "TX",
    "property_address_zip": "78653",
    "property_address_latitude": "30.3387867",
    "property_address_longitude": "-97.60225589999999",
    "property_phone": "(737) 703-1750",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019f6c0e-71bc-7338-a224-0ff2ef6ae779.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163351/019e6a7c-3220-770a-8e34-16af50639ae1.webp",
    "property_primary_color": "#31261d",
    "property_price_range": "1162.33 - 2201.5",
    "property_price_min": "1162.33",
    "property_price_max": "2201.5",
    "property_bedrooms_range": "studio - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "582 - 1580",
    "property_short_description": "<p><strong>Modern Manor living with room to spread out.</strong> Explore studio to three-bedroom apartments with polished finishes, smart everyday features, and resort-style spaces near US 290 and SH 130—then schedule your tour of Eightyone10 Blue Goose.</p>",
    "property_type": "apartment",
    "property_total_units": "300",
    "property_website_url": "https://www.eightyone10.com/",
    "property_domain": "https://www.eightyone10.com/",
    "property_company_name": "American Landmark",
    "_slug": "eightyone10-blue-goose",
    "_stateSlug": "tx",
    "_citySlug": "manor"
  },
  {
    "multihub_property_id": "6767906449163353",
    "multihub_company_id": "5695708787113984",
    "property_name": "Revel",
    "property_slug": "revel",
    "property_address": "5950 Dezer Way",
    "property_address_1": "5950 Dezer Wy",
    "property_address_city": "Orlando",
    "property_address_state": "FL",
    "property_address_zip": "32819",
    "property_address_latitude": "28.465893",
    "property_address_longitude": "-81.446562",
    "property_phone": "689-288-8497",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163353/019f8b77-0cc6-7277-9609-e885dcdf5843.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163353/019f8b77-079e-7293-8ffd-971275b838e8.webp",
    "property_primary_color": "#454142",
    "property_short_description": "<p><strong>New Orlando apartments with I-Drive energy.</strong> Explore open-concept one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with quartz countertops, stainless-steel appliances, in-home laundry, and polished community spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Revel for yourself.</p>",
    "property_type": "apartment",
    "property_total_units": "365",
    "property_website_url": "https://www.revelorlando.com/",
    "property_domain": "https://www.revelorlando.com/",
    "property_company_name": "American Landmark",
    "_slug": "revel",
    "_stateSlug": "fl",
    "_citySlug": "orlando"
  },
  {
    "multihub_property_id": "6767906449163356",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Quinn",
    "property_slug": "the-quinn",
    "property_address": "462 Lucy Lou Place",
    "property_address_1": "462 Lucy Lou Pl",
    "property_address_city": "Brandon",
    "property_address_state": "FL",
    "property_address_zip": "33511",
    "property_address_latitude": "27.9311235",
    "property_address_longitude": "-82.3077375",
    "property_phone": "813-819-3594",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163356/019d02f6-0620-73e8-a04c-0e8dee1e95a7.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163356/019d02f6-e434-7206-ba42-ade3bfff6ed5.webp",
    "property_primary_color": "#3d5574",
    "property_short_description": "<p><strong>Modern studio living in Brandon.</strong> The Quinn pairs polished in-home finishes with resort-inspired comforts and easy access around Tampa Bay. Browse <a href=\"/floor-plans\">available studio layouts</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
    "property_type": "apartment",
    "property_total_units": "360",
    "property_website_url": "https://www.lifeatthequinn.com/",
    "property_domain": "https://www.lifeatthequinn.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-quinn",
    "_stateSlug": "fl",
    "_citySlug": "brandon"
  },
  {
    "multihub_property_id": "6767906449163357",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Griffin",
    "property_slug": "the-griffin",
    "property_address": "1131 Courtney Trace Dr",
    "property_address_1": "1131 Courtney Trace Dr",
    "property_address_city": "Brandon",
    "property_address_state": "FL",
    "property_address_zip": "33511",
    "property_address_latitude": "27.9196491",
    "property_address_longitude": "-82.3319635",
    "property_phone": "(813) 651-4340",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-2cfd-759f-9fda-faeed1d85491.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e73d2-4262-75cc-bca5-a36e22190d0b.webp",
    "property_primary_color": "#90906f",
    "property_price_range": "1530.5 - 2383.5",
    "property_price_min": "1530.5",
    "property_price_max": "2383.5",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "822 - 1570",
    "property_short_description": "<p><strong>Modern Brandon living with room to spread out.</strong> Choose spacious one-, two-, and three-bedroom apartments or townhome-style layouts with elevated finishes, smart home features, and in-home laundry—then explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> of The Griffin.</p>",
    "property_type": "apartment",
    "property_total_units": "455",
    "property_website_url": "https://www.liveatthegriffin.com",
    "property_domain": "https://www.liveatthegriffin.com/",
    "property_company_name": "American Landmark",
    "_slug": "the-griffin",
    "_stateSlug": "fl",
    "_citySlug": "brandon"
  },
  {
    "multihub_property_id": "6767906449166279",
    "multihub_company_id": "5695708787113984",
    "property_name": "Vinoy at St. Johns",
    "property_slug": "vinoy-at-st.-johns",
    "property_address": "12310 Seacrest Ln",
    "property_address_1": "12310 Seacrest Lane",
    "property_address_city": "Jacksonville",
    "property_address_state": "FL",
    "property_address_zip": "32224",
    "property_address_latitude": "26.4897765",
    "property_address_longitude": "-80.0699843",
    "property_phone": "(904) 643-5325",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166279/019e8a0a-5442-70fc-8066-6e56943bada6.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166279/019d02f7-d472-7228-afde-b90b919c835c.webp",
    "property_primary_color": "#40403e",
    "property_price_range": "1225 - 2140",
    "property_price_min": "1225",
    "property_price_max": "2140",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "756 - 1376",
    "property_short_description": "<p><strong>Resort-inspired Southside Jacksonville apartments.</strong> Discover one-, two-, and three-bedroom homes with quartz countertops, stainless steel appliances, generous closets, and private outdoor space—then schedule your tour at Vinoy at St. Johns.</p>",
    "property_type": "apartment",
    "property_total_units": "420",
    "property_website_url": "https://www.vinoyatstjohns.com",
    "property_domain": "https://www.vinoyatstjohns.com/",
    "property_company_name": "American Landmark",
    "_slug": "vinoy-at-st-johns",
    "_stateSlug": "fl",
    "_citySlug": "jacksonville"
  },
  {
    "multihub_property_id": "6767906449167307",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Vale at Baymeadows",
    "property_slug": "the-vale-at-baymeadows",
    "property_address": "7820 Baymeadows Rd E",
    "property_address_1": "7820 Baymeadows Rd E",
    "property_address_city": "Jacksonville",
    "property_address_state": "FL",
    "property_address_zip": "32256",
    "property_address_latitude": "30.2303719",
    "property_address_longitude": "-81.5123235",
    "property_phone": "(904) 998-4303",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-1e94-71ee-b836-648421bc9b7b.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-2d20-7072-856d-40f1d60fbc55.webp",
    "property_primary_color": "#afbfad",
    "property_price_range": "2025",
    "property_price_max": "2025",
    "property_bedrooms_range": "1-3",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1-2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "1",
    "property_sqft_range": "827 - 1247",
    "property_short_description": "<p><strong>Modern Southside living with a lakeside feel.</strong> Discover spacious one-, two-, and three-bedroom apartments with open layouts, in-home laundry, private outdoor space, and select lake or pool views—then explore available floor plans to find your fit.</p>",
    "property_type": "apartment",
    "property_total_units": "276",
    "property_website_url": "https://www.thevaleatbaymeadows.com/",
    "property_domain": "https://www.thevaleatbaymeadows.com",
    "property_company_name": "American Landmark",
    "_slug": "the-vale-at-baymeadows",
    "_stateSlug": "fl",
    "_citySlug": "jacksonville"
  },
  {
    "multihub_property_id": "6767906449167308",
    "multihub_company_id": "5695708787113984",
    "property_name": "The Aubrey Sweetwater",
    "property_slug": "the-aubrey-sweetwater",
    "property_address": "2222 E West Connector",
    "property_address_1": "2222 E West Connector",
    "property_address_city": "Austell",
    "property_address_state": "GA",
    "property_address_zip": "30106",
    "property_address_latitude": "33.8634646",
    "property_address_longitude": "-84.6209666",
    "property_phone": "6788904035",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167308/01a00210-c9c6-722e-a193-f15beb7c3b6a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167308/019d02f8-1b8c-749d-9f1e-a6ed5d2e833a.webp",
    "property_primary_color": "#2c3111",
    "property_price_range": "1295 - 2085",
    "property_price_min": "1295",
    "property_price_max": "2085",
    "property_bedrooms_range": "1-3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1-2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "811 - 1475",
    "property_short_description": "<p><strong>Relaxed West Cobb living, connected to what matters.</strong> Explore spacious <a href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a> in a serene Austell setting along the East-West Connector, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see polished finishes, inviting community spaces, and everyday convenience up close.</p>",
    "property_type": "apartment",
    "property_total_units": "324",
    "property_website_url": "https://www.theaubreysweetwater.com",
    "property_domain": "https://www.theaubreysweetwater.com",
    "property_company_name": "American Landmark",
    "_slug": "the-aubrey-sweetwater",
    "_stateSlug": "ga",
    "_citySlug": "austell"
  },
  {
    "multihub_property_id": "6767906449167309",
    "multihub_company_id": "5695708787113984",
    "property_name": "Preserve at Mill Creek",
    "property_slug": "preserve-at-mill-creek",
    "property_address": "1400 Mall of Georgia Blvd",
    "property_address_1": "1400 Mall of Georgia Blvd",
    "property_address_city": "Buford",
    "property_address_state": "GA",
    "property_address_zip": "30519",
    "property_address_latitude": "34.0591003",
    "property_address_longitude": "-83.99889379999999",
    "property_phone": "(678) 714-9333",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/01a04902-c43f-72c2-814f-8570a7c244c9.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167309/019e2205-64f8-757d-9c62-948cdca184f2.webp",
    "property_primary_color": "#014f71",
    "property_price_range": "2235",
    "property_price_min": "1400",
    "property_price_max": "2235",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "697 - 1406",
    "property_short_description": "<p><strong>Modern comfort beside Mall of Georgia energy.</strong> Explore roomy one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment homes</a> with open-concept kitchens, quartz countertops, walk-in closets, and private outdoor space—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Preserve at Mill Creek in person.</p>",
    "property_type": "apartment",
    "property_total_units": "400",
    "property_website_url": "https://www.preserveatmillcreekapts.com/",
    "property_domain": "https://www.preserveatmillcreek.com/",
    "property_company_name": "American Landmark",
    "_slug": "preserve-at-mill-creek",
    "_stateSlug": "ga",
    "_citySlug": "buford"
  },
  {
    "multihub_property_id": "6767906449167486",
    "multihub_company_id": "5695708787113984",
    "property_name": "Azure Carnes Crossing",
    "property_slug": "azure-carnes-crossing",
    "property_address": "900 Conway Cir",
    "property_address_1": "900 Conway Cir",
    "property_address_city": "Summerville",
    "property_address_state": "SC",
    "property_address_zip": "29486",
    "property_address_latitude": "33.0592594",
    "property_address_longitude": "-80.091554",
    "property_phone": "(843) 821-7970",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-acea-7354-bc02-6f9b29afdd2a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e21fe-9fb8-7368-a741-dd4149dd2859.webp",
    "property_primary_color": "#006a71",
    "property_price_range": "1370 - 2285",
    "property_price_min": "1370",
    "property_price_max": "2285",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "684 - 1559",
    "property_short_description": "<p><strong>Modern Summerville apartment living, polished down to the details.</strong> Azure Carnes Crossroads pairs gourmet kitchens, spa-inspired baths, and spacious closets with inviting social spaces and a resort-inspired pool—explore the <a href=\"/amenities\">signature features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
    "property_type": "apartment",
    "property_total_units": "295",
    "property_website_url": "https://www.lifeatazure.com/",
    "property_domain": "https://www.lifeatazure.com/",
    "property_company_name": "American Landmark",
    "_slug": "azure-carnes-crossing",
    "_stateSlug": "sc",
    "_citySlug": "summerville"
  },
  {
    "multihub_property_id": "6767906449167502",
    "multihub_company_id": "5695708787113984",
    "property_name": "Toscana Parkway",
    "property_slug": "toscana-parkway",
    "property_address": "11575 Pearland Pkwy",
    "property_address_1": "11575 Pearland Pkwy",
    "property_address_city": "Houston",
    "property_address_state": "TX",
    "property_address_zip": "77089",
    "property_address_latitude": "29.5972743",
    "property_address_longitude": "-95.260977",
    "property_phone": "713-987-2204",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167502/019e3bb3-76e6-74a8-aa6b-2b9cf049e2d0.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167502/019e8434-0d9a-7557-8a40-2a3a0f3d1def.webp",
    "property_primary_color": "#758692",
    "property_price_range": "1275 - 2232.5",
    "property_price_min": "1275",
    "property_price_max": "2232.5",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "824 - 1317",
    "property_short_description": "<p>Experience elevated living at Toscana Parkway, where modern apartment homes and resort-style amenities come together in the heart of Houston, TX. Choose from spacious, pet-friendly floor plans designed for your lifestyle, featuring contemporary finishes, functional layouts, and the comfort you deserve. Enjoy community perks like a sparkling swimming pool with poolside Wi-Fi, a fully equipped fitness center, and an executive business center, all designed to help you relax, recharge, and stay connected. Whether you’re working from home, entertaining guests, or enjoying time with your pets, Toscana Parkway offers the perfect place to call home.</p>",
    "property_type": "apartment",
    "property_total_units": "292",
    "property_website_url": "https://www.toscanaparkway.com/",
    "property_domain": "https://www.toscanaparkway.com/",
    "property_company_name": "American Landmark",
    "_slug": "toscana-parkway",
    "_stateSlug": "tx",
    "_citySlug": "houston"
  },
  {
    "multihub_property_id": "6767906449167503",
    "multihub_company_id": "5695708787113984",
    "property_name": "Woodland Pointe Residences",
    "property_slug": "woodland-pointe-residences",
    "property_address": "1501 Woodland Pointe Dr",
    "property_address_1": "1501 Woodland Pointe Dr",
    "property_address_city": "Nashville",
    "property_address_state": "TN",
    "property_address_zip": "37214",
    "property_address_latitude": "36.1238999",
    "property_address_longitude": "-86.6286707",
    "property_phone": "6158722562",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/01a01636-8b6c-7209-9e73-d3a40974f992.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167503/019e8432-8c5e-775a-9fe1-fcac9536a74e.webp",
    "property_primary_color": "#172138",
    "property_price_range": "1417.33 - 2228.66",
    "property_price_min": "1417.33",
    "property_price_max": "2228.66",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "677 - 1491",
    "property_short_description": "<p><strong>Welcome home to Woodland Pointe Residences.</strong> Spacious 1, 2, and 3-bedroom apartments from 735 to 1,491 sq. ft. pair modern style with open living just minutes from Nashville. Explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
    "property_type": "apartment",
    "property_total_units": "240",
    "property_website_url": "https://www.lifeatwoodland.com/",
    "property_domain": "https://www.lifeatwoodland.com/",
    "property_company_name": "American Landmark",
    "_slug": "woodland-pointe-residences",
    "_stateSlug": "tn",
    "_citySlug": "nashville"
  },
  {
    "multihub_property_id": "6767906449167525",
    "multihub_company_id": "5695708787113984",
    "property_name": "Levi at River City",
    "property_slug": "levi-at-river-city",
    "property_address": "13100 Broxton Bay Dr",
    "property_address_1": "13100 Broxton Bay Dr",
    "property_address_city": "Jacksonville",
    "property_address_state": "FL",
    "property_address_zip": "32218",
    "property_address_latitude": "30.4751408",
    "property_address_longitude": "-81.6362741",
    "property_phone": "(904) 714-9101",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167525/019e83c0-aff9-719c-8711-9c926353eabc.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167525/019f0498-7ef2-775f-8af2-50a3502a2e0f.webp",
    "property_primary_color": "#363936",
    "property_price_range": "1270 - 1795",
    "property_price_min": "1270",
    "property_price_max": "1795",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "800 - 1523",
    "property_short_description": "<p><strong>Refreshed, resort-inspired living in Northside Jacksonville.</strong> Explore bright one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with chef’s kitchens, in-home laundry, walk-in closets, and private outdoor space—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Levi at River City in person.</p>",
    "property_type": "apartment",
    "property_total_units": "552",
    "property_website_url": "https://www.liveatleviapts.com/",
    "property_domain": "https://www.liveatleviapts.com/",
    "property_company_name": "American Landmark",
    "_slug": "levi-at-river-city",
    "_stateSlug": "fl",
    "_citySlug": "jacksonville"
  },
  {
    "multihub_property_id": "6767906449167532",
    "multihub_company_id": "5695708787113984",
    "property_name": "Tortuga Bayside",
    "property_slug": "tortuga-bayside",
    "property_address": "10475 Gandy Blvd N",
    "property_address_1": "10475 Gandy Blvd N",
    "property_address_city": "St. Petersburg",
    "property_address_state": "FL",
    "property_address_zip": "33702",
    "property_address_latitude": "27.8686849",
    "property_address_longitude": "-82.6282197",
    "property_phone": "(727) 860-1056",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167532/01a01b76-2b8a-71a0-bfc5-bde1270c76e0.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167532/019f04b0-99d6-77df-831c-5de4748f72ed.webp",
    "property_primary_color": "#394a61",
    "property_price_range": "$1637 - $2900",
    "property_price_min": "1645",
    "property_price_max": "2980",
    "property_bedrooms_range": "0 - 3",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "568 - 1424",
    "property_short_description": "<p><strong>Bayside St. Petersburg living starts at Tortuga Bayside.</strong> Explore studio to three-bedroom apartments with open-concept layouts, in-home washer/dryer convenience, and select upgraded finishes, all with easy access to daily essentials, work hubs, and waterfront escapes.</p>",
    "property_type": "apartments",
    "property_total_units": "295",
    "property_website_url": "https://www.tortugabayside.com/",
    "property_domain": "https://www.tortugabayside.com/",
    "property_company_name": "American Landmark",
    "_slug": "tortuga-bayside",
    "_stateSlug": "fl",
    "_citySlug": "st-petersburg"
  },
  {
    "multihub_property_id": "6767906449167533",
    "multihub_company_id": "5695708787113984",
    "property_name": "Savona Grand",
    "property_slug": "savona-grand",
    "property_address": "7132 Colony Club Dr",
    "property_address_1": "7132 Colony Club Dr",
    "property_address_city": "Lake Worth Beach",
    "property_address_state": "FL",
    "property_address_zip": "33463",
    "property_address_latitude": "26.5689028",
    "property_address_longitude": "-80.11180019999999",
    "property_phone": "(561) 641-3221",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019f8d82-d041-777f-a411-5b1aaac3fd07.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167533/019f8682-4510-746f-a97d-845d1289a5dd.webp",
    "property_primary_color": "#3E5A6A",
    "property_price_range": "1965 - 3060",
    "property_price_min": "2137",
    "property_price_max": "3060",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "824 - 1489",
    "property_short_description": "<p><strong>Polished Palm Beach County apartment living, tucked beside scenic ponds.</strong> Explore spacious one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with full-size washers and dryers, generous storage, and select upgraded finishes—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Savona Grand in Lake Worth Beach.</p>",
    "property_total_units": "214",
    "property_website_url": "https://www.liveatsavona.com/",
    "property_domain": "https://www.liveatsavona.com/",
    "property_company_name": "American Landmark",
    "_slug": "savona-grand",
    "_stateSlug": "fl",
    "_citySlug": "lake-worth-beach"
  },
  {
    "multihub_property_id": "6767906449167731",
    "multihub_company_id": "5695708787113984",
    "property_name": "Hue Watercolor Place",
    "property_slug": "hue-watercolor-place",
    "property_address": "215 107th St Cir E",
    "property_address_1": "215 107th St Cir E",
    "property_address_city": "Bradenton",
    "property_address_state": "FL",
    "property_address_zip": "34212",
    "property_address_latitude": "27.5026762",
    "property_address_longitude": "-82.43569",
    "property_phone": "(941) 417-3283",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167731/01a03a20-a8a5-736a-a281-ff6cbc8f6edc.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167731/01a03a20-a827-71c9-9219-58f3083ca70d.webp",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "684 - 1,547 sq ft",
    "property_short_description": "<p><strong>Colorful Bradenton living with room to recharge.</strong> Discover open-concept two- and three-bedroom apartments with polished finishes, everyday conveniences, and resort-inspired spaces designed for an easy Gulf Coast home base.</p>",
    "property_type": "Apartments",
    "property_total_units": "380",
    "property_website_url": "https://www.huewatercolorplace.com/",
    "property_company_name": "American Landmark",
    "_slug": "hue-watercolor-place",
    "_stateSlug": "fl",
    "_citySlug": "bradenton"
  },
  {
    "multihub_property_id": "6767906449167732",
    "multihub_company_id": "5695708787113984",
    "property_name": "Sol Riverside",
    "property_slug": "sol-riverside",
    "property_address": "2502 Riverside Pkwy",
    "property_address_1": "2502 Riverside Pkwy",
    "property_address_city": "Grand Prairie",
    "property_address_state": "TX",
    "property_address_zip": "75050",
    "property_address_latitude": "32.7925761",
    "property_address_longitude": "-97.06095309999999",
    "property_phone": "(817) 530-1919",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167732/01a03a22-6e09-77ba-bf40-84b237679c05.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167732/01a06801-326c-703e-b2d2-ea93c80eb6fd.webp",
    "property_primary_color": "#4e6548",
    "property_price_range": "1264 - 2511",
    "property_price_min": "1264",
    "property_price_max": "2511",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "623 - 1342",
    "property_short_description": "<p><strong>Connected living with room to unwind.</strong> Explore one-, two-, and three-bedroom apartments with bright oversized windows, hardwood-style flooring, modern cabinetry, and stainless steel appliances—then schedule your tour of Sol Riverside today.</p>",
    "property_type": "Apartments",
    "property_total_units": "350",
    "property_website_url": "https://www.solriverside.com/",
    "property_domain": "https://www.solriverside.com/",
    "property_company_name": "American Landmark",
    "_slug": "sol-riverside",
    "_stateSlug": "tx",
    "_citySlug": "grand-prairie"
  }
];

export const generatedAt = '2026-11-04T18:50:09.297Z';
